export const workspace = {
codeLanguagesLabel: "Codesprache",
codeLanguages: {
curl: "curl",
js: "JavaScript",
python: "Python",
powerQuery: "Power Query",
powershell: "PowerShell",
},
overviewScreen: {
loading: "Arbeitsbereich wird geladen…",
fallbackWorkspaceName: "Arbeitsbereich",
fallbackTeamName: "Team",
fallbackPersonalName: "Persönlich",
notSet: "Nicht gesetzt",
roleUnavailable: "Rolle nicht verfügbar",
personalMode: "Persönlicher Modus",
addSummaryHint: "Fügen Sie eine kurze Zusammenfassung im Organisationsprofil hinzu.",
currentContextLabel: "Aktueller Kontext",
yourRoleLabel: "Ihre Rolle",
currencyLabel: "Währung",
languageLabel: "Sprache",
manageOrgA11y: "Organisationsprofil verwalten",
viewOrgA11y: "Organisationsprofil anzeigen",
manageOrgTitle: "Organisation verwalten",
viewOrgTitle: "Organisation anzeigen",
manageOrgSubtitle: "Profil, rechtliche Details und Unternehmensübersicht.",
teamsA11y: "Teams und Einladungen",
teamsTitle: "Teams und Einladungen",
teamsSubtitle: "Kontext wechseln, Mitgliedschaften und Einladungen.",
configurationTitle: "Konfiguration",
configurationSubtitle: "Alles, was Sie einrichten können, gruppiert nach Bereichen.",
groupWorkspaceLabel: "Arbeitsbereich",
groupOperationsLabel: "Betrieb",
groupTemplatesLabel: "Checklisten",
groupIntegrationsLabel: "Integrationen",
groupAiLabel: "KI",
groupBillingLabel: "Abrechnung",
groupSupportLabel: "Unterstützung",
itemOrgProfileTitle: "Organisationsprofil",
itemOrgProfileSubtitleAdmin: "Firmenname, Branche, Adresse und private Notizen.",
itemOrgProfileSubtitleMember: "Sehen Sie sich den offiziellen Namen, die Branche und die Adresse an.",
itemTeamsTitle: "Teams und Einladungen",
itemTeamsSubtitleAdmin: "Mitglieder, Rollen, Kontextwechsel und Einladungen.",
itemTeamsSubtitleMember: "Mitglieder und Rollen anzeigen; Kontext wechseln.",
itemBrandingTitle: "Berichts-Branding",
itemBrandingSubtitleAdmin: "Logo und Firmendetails nur für PDFs, Freigaben und Exporte.",
itemBrandingSubtitleMember: "Sehen Sie sich das Logo und die Firmendetails an, die in PDFs, Freigaben und Exporten verwendet werden.",
itemContractorWorkTitle: "Meine Arbeit als Auftragnehmer",
itemContractorWorkSubtitle: "Arbeitsaufträge und Angebotsanfragen, die Ihnen andere Arbeitsbereiche gesendet haben.",
itemMaintenancePlansTitle: "Wartungspläne",
itemMaintenancePlansSubtitle: "Alle wiederkehrenden Pläne des Arbeitsbereichs, nach Anlage gruppiert.",
itemFeaturesTitle: "Funktionen",
itemFeaturesSubtitle: "Was aktiv, durch den Tarif gesperrt oder abgeschaltet ist.",
itemDefaultsTitle: "Regionale Standardeinstellungen",
itemDefaultsSubtitle: "Währung, Sprache, Zeitzone und Freigabemethoden.",
itemTemplatesTitle: "Checklisten",
itemTemplatesSubtitle: "Wiederverwendbare Inspektionschecklisten.",
itemIndustryPacksTitle: "Branchenpakete",
itemIndustryPacksSubtitle: "Ausgangspunkte für Immobilien, Fuhrpark, Ausrüstung und Einrichtungen.",
itemIntegrationsTitle: "Integrationen & API",
itemIntegrationsSubtitle: "Importe, öffentliche API, MCP, Automatisierungen und verbundene Anlagen.",
itemAiAuditTitle: "KI- & Automatisierungsaudit",
itemAiAuditSubtitle: "KI-Nutzung und Automatisierungsaktivität im Arbeitsbereich.",
itemBillingTitle: "Abrechnung & Nutzung",
itemBillingSubtitleAdmin: "Tarif, KI-Credits, abrechenbare Anlagen und Credit-Buchungen.",
itemBillingSubtitleMember: "Tarif und Credit-Verbrauch anzeigen; nur ein Admin kann sie ändern.",
itemHandbookTitle: "Integrationshandbuch",
itemHandbookSubtitle: "Anleitungen zum Verbinden und Automatisieren von AssetWRX.",
},
organizationScreen: {
  allSaved: "Gespeichert. Die Angaben Ihres Arbeitsbereichs sind aktuell.",
  allChangesSaved: "Alle Änderungen gespeichert",
  saveChanges: "Änderungen speichern",
  unsavedKeep: "Weiter bearbeiten",
  unsavedDiscard: "Verlassen",
  unsavedBody: "Sie haben Angaben auf dieser Seite geändert. Wenn Sie jetzt gehen, gehen diese Änderungen verloren.",
  unsavedTitle: "Ohne Speichern verlassen?",
pageTitle: "Organisationsprofil",
pageSubtitle: "Identität, Kontaktdaten und rechtliche Angaben des Arbeitsbereichs. Die Gestaltung des Berichtskopfs finden Sie unter „Berichte“.",
memberNotice: "Nur Inhaber des Arbeitsbereichs können Organisationsdetails und das Berichts-Branding bearbeiten. Unten können Sie die geteilten Informationen einsehen.",
loadingProfile: "Organisationsprofil wird geladen…",
fallbackWorkspaceName: "Arbeitsbereich",
logoSectionTitle: "Workspace-Logo",
changeLogoA11y: "Arbeitsbereichslogo ändern",
uploading: "Hochladen…",
changeLogo: "Logo ändern",
removeLogoA11y: "Logo entfernen",
remove: "Entfernen",
workspaceNameLabel: "Workspace-Name",
workspaceNamePlaceholder: "Arbeitsbereichsbezeichnung",
saveWorkspaceName: "Arbeitsbereichsnamen speichern",
organizationSectionTitle: "Organisation",
summaryLabel: "Übersicht",
summaryPlaceholder: "Kurze Beschreibung Ihrer Organisation",
industryLabel: "Branche",
companySizeLabel: "Unternehmensgröße",
companySizePlaceholder: "z.B. 1–10, 11–50",
websiteLabel: "Webseite",
websitePlaceholder: "https://example.com",
countryCodeLabel: "Ländercode",
countryCodePlaceholder: "z.B. GB",
regionLabel: "Gebiet",
saveOrganization: "Organisation speichern",
supportContactsTitle: "Support-Kontakte",
supportEmailLabel: "Support-E-Mail",
supportPhoneLabel: "Support-Telefon",
saveSupportContacts: "Support-Kontakte speichern",
legalBillingTitle: "Rechtliches und Abrechnung",
legalBillingSubtitle: "Nur für Arbeitsbereichsbesitzer sichtbar.",
legalEntityNameLabel: "Name der juristischen Person",
tradingNameLabel: "Handels-/Anzeigename",
primaryContactEmailLabel: "Hauptkontakt-E-Mail",
primaryContactPhoneLabel: "Hauptkontakttelefon",
registeredAddressLabel: "Registrierte Adresse",
operationalAddressLabel: "Betriebsadresse",
taxNumberLabel: "Steuer-/Mehrwertsteuernummer",
registrationNumberLabel: "Handelsregisternummer",
billingContactNameLabel: "Rechnungskontaktname",
billingContactEmailLabel: "Rechnungskontakt-E-Mail",
billingContactPhoneLabel: "Telefonnummer des Abrechnungskontakts",
saveLegalBilling: "Rechtliches und Abrechnung speichern",
memberPrivateNote: "Angaben zu juristischen Personen, Steuern, Registrierung und Rechnungen sind auf Workspace-Inhaber beschränkt.",
reportBrandingLink: "Berichtsbranding und Exporte",
savedTitle: "Gespeichert",
workspaceNameSaved: "Arbeitsbereichsname aktualisiert.",
saveFailedTitle: "Speichern fehlgeschlagen",
couldNotSave: "Konnte nicht gespeichert werden.",
checkPhoneTitle: "Telefonnummer prüfen",
checkPhoneBody: "Geben Sie eine gültige Nummer für das gewählte Land ein oder lassen Sie das Feld leer.",
organizationDetailsSaved: "Organisationsdetails aktualisiert.",
legalBillingSaved: "Rechtliche und Rechnungsdetails aktualisiert.",
permissionRequiredTitle: "Berechtigung erforderlich",
permissionRequiredBody: "Bitte erlauben Sie den Zugriff auf die Fotobibliothek, um ein Logo hochzuladen.",
fileTooLargeTitle: "Datei zu groß",
fileTooLargeBody: "Logo darf maximal 10 MB groß sein.",
logoUpdated: "Workspace-Logo aktualisiert.",
uploadFailedTitle: "Upload fehlgeschlagen",
couldNotUploadLogo: "Logo konnte nicht hochgeladen werden.",
removedTitle: "Entfernt",
logoRemoved: "Workspace-Logo entfernt.",
removeFailedTitle: "Entfernen fehlgeschlagen",
couldNotRemoveLogo: "Logo konnte nicht entfernt werden.",
},
brandingScreen: {
readOnlyTitle: "Schreibgeschützt",
readOnlyBody: "Nur Arbeitsbereichsbesitzer können das Berichts-Branding ändern.",
permissionRequiredTitle: "Berechtigung erforderlich",
permissionRequiredBody: "Bitte erlauben Sie den Zugriff auf die Fotobibliothek, um ein Logo hochzuladen.",
fallbackWorkspaceName: "Arbeitsbereich",
workspaceBrandingAppliedTitle: "Workspace-Branding angewendet",
workspaceBrandingAppliedBody: "Name und Logo des Arbeitsbereichs wurden in die Berichts-Branding-Felder kopiert. Prüfen Sie die Angaben und speichern Sie, um sie zu übernehmen.",
noWorkspaceTitle: "Kein Arbeitsbereich",
noWorkspaceBody: "Ihr Profil verfügt noch über kein Workspace-Konto.",
savedTitle: "Gespeichert",
brandingSaved: "Branding-Einstellungen für Berichte aktualisiert.",
saveFailedTitle: "Speichern fehlgeschlagen",
couldNotSaveBranding: "Die Branding-Einstellungen des Berichts konnten nicht gespeichert werden.",
intro: "Wird auf gehostete Berichte, PDF-Exporte, geteilte Inspektionsergebnisse und Freigabe-E-Mails angewendet. Legen Sie hier Felder fest, um das Standard-AssetWRX-Branding für diese Ausgaben zu ersetzen. Lassen Sie sie leer, um die AssetWRX-Standardeinstellungen beizubehalten.",
memberHint: "Nur Workspace-Inhaber können das Branding bearbeiten. Sie können die aktuellen Einstellungen unten überprüfen.",
fromReportHint: "Dieser Abschnitt wurde über den Berichtsarbeitsbereich geöffnet. Änderungen gelten sofort für gehostete Berichte und neue Exporte.",
loadingSettings: "Branding-Einstellungen werden geladen…",
reportLogoLabel: "Berichtslogo",
reportLogoHint: "Wird nur für Berichte, PDF-Exporte und Freigabe-E-Mails verwendet.",
changeLogoA11y: "Ändern Sie das Logobild des Berichts",
addLogoA11y: "Berichtslogobild hinzufügen",
changeLogo: "Berichtslogo ändern",
addLogo: "Berichtslogo hinzufügen",
removeLogoA11y: "Berichtslogo entfernen",
removeLogo: "Berichtslogo entfernen",
copyFromWorkspaceA11y: "Verwenden Sie das Logo und den Namen Ihres Arbeitsbereichs für Berichte",
copyFromWorkspace: "Logo und Namen meines Arbeitsbereichs verwenden",
noLogoHint: "Kein Berichtslogo festgelegt – Exporte verwenden das AssetWRX-Branding, bis Sie hier eines hinzufügen.",
companyNameLabel: "Firma/Anzeigename",
companyNamePlaceholder: "z.B. Northfield Property Services",
companyNameA11y: "Firma oder Anzeigename für Berichte",
addressBlockLabel: "Adressblock",
addressBlockPlaceholder: "Adresszeilen werden im Berichtskopf angezeigt",
addressBlockA11y: "Adressblock des Berichts",
contactBlockLabel: "Kontaktblock",
contactBlockPlaceholder: "E-Mail / Telefon / Website",
contactBlockA11y: "Kontaktblock des Berichts",
footerLabel: "Fußzeile/Haftungsausschluss",
footerPlaceholder: "Optionaler Haftungsausschluss für die Berichtsfußzeile",
footerA11y: "Fußzeile oder Haftungsausschluss des Berichts",
accentColorLabel: "Akzentfarbe (optional)",
accentColorA11y: "Hexwert der Akzentfarbe des Berichts",
accentColorHint: "Verwenden Sie das Hex-Format (#RRGGBB). Lassen Sie das Feld leer, um den Standardakzent AssetWRX zu verwenden.",
savingA11y: "Speichern des Berichts-Brandings",
saveA11y: "Speichern Sie die Branding-Einstellungen des Berichts",
saving: "Wird gespeichert…",
saveBranding: "Branding speichern",
},
teamsScreen: {
recentlyJoined: "Kürzlich beigetreten",
switchFailedTitle: "Der Arbeitsbereich konnte nicht gewechselt werden",
tryAgain: "Bitte erneut versuchen.",
pendingInviteTitle: "Ausstehende Teameinladung",
pendingInviteBody_one: "{{count}} Einladung wartet im Teammanagement.",
pendingInviteBody_other: "{{count}} Einladungen warten im Teammanagement.",
teamManagementTitle: "Teammanagement",
teamManagementSubtitle: "Einladungen, Rollen und erweiterte Optionen.",
createFirstTeam: "Erstellen Sie Ihr erstes Team",
openTeamManagement: "Teammanagement öffnen",
teamManagementMenuSubtitle: "Vollbildeinstellungen für Ihre Teams und Einladungen.",
teamsAndContextTitle: "Ihre Teams",
teamsAndContextSubtitle: "Das Team, in dem Sie arbeiten, und alle Teams, denen Sie angehören.",
changeContext: "Team wechseln",
workspaceLabel: "Arbeitsbereich",
currentContextLabel: "Sie arbeiten in",
roleInContextLabel: "Ihre Rolle",
loadFailed: "Ihre Teams konnten nicht geladen werden. Öffnen Sie diese Seite erneut, um es noch einmal zu versuchen.",
teamMembershipsTitle: "Teammitgliedschaften",
manageInTeamSettings: "In den Teameinstellungen verwalten",
noMemberships: "Sie sind derzeit in keinem Team.",
membershipMeta: "Rolle: {{role}} · Beigetreten {{date}}",
currentBadge: "Aktuell",
workingContextTitle: "Team wechseln",
workingContextSubtitle: "Wählen Sie, von welchem Team Sie Anlagen und Arbeit sehen. Persönlich zeigt nur Ihre eigenen.",
personalOption: "Persönlich",
},
aiUsageInsights: {
title: "Einblicke in die KI-Nutzung",
subtitle: "Fasst Aufrufe, Credits und Feedback der letzten {{days}} Tage zusammen. Wird beim Aktualisieren neu geladen.",
refresh: "Aktualisieren",
loadingUsage: "Nutzung wird geladen…",
alertHeader_one: "{{count}} Funktion muss überprüft werden",
alertHeader_other: "{{count}} Funktionen müssen überprüft werden",
healthAttention: "Einige KI-Funktionen erfordern Aufmerksamkeit – ein Workspace-Administrator kann die Details überprüfen.",
healthNormal: "Alle KI-Funktionen laufen normal.",
kpiCreditsBurned: "Verbrauchte Credits",
kpiCalls: "Aufrufe",
kpiErrors: "Fehler",
kpiCacheHitRate: "Cache-Trefferquote",
projectedMonthly: "Monatliche Prognose",
pctOfBudget: "{{pct}} % des {{budget}}-Budgets",
extrapolatedFromWindow: "Linear hochgerechnet aus diesem Zeitraum von {{days}} Tagen",
noActivity: "Keine KI-Aktivität in diesem Zeitraum. Ermutigen Sie Benutzer, den Copiloten auszuprobieren, damit hier Daten erscheinen.",
colCapability: "Funktion",
colCalls: "Aufrufe",
colCredits: "Credits",
colAvgMs: "Durchschn. ms",
colFeedback: "👍 / 👎",
colAccept: "Angenommen",
openDetailHint: "Funktionsdetails öffnen",
alert: {
neverHelpful_one: "{{count}} negative Bewertung und keine positive. Deutliches Zeichen, dass etwas nicht stimmt.",
neverHelpful_other: "{{count}} negative Bewertungen und keine positive. Deutliches Zeichen, dass etwas nicht stimmt.",
lowAcceptance: "Annahmequote {{pct}} % (n={{total}}). Prompt oder Beispiele prüfen.",
highErrorRate: "{{pct}} % der Aufrufe schlagen fehl ({{errors}}/{{calls}}). Edge Function oder Modellverfügbarkeit prüfen.",
},
feature: {
unknown: "Nicht zugeordnet",
ai_assistant: "KI-Assistent",
connected_event: "Ereignis eines verbundenen Geräts",
automation: {
asset_health_calculated: "Anlagenzustand berechnet",
asset_compliance_calculated: "Anlagenkonformität berechnet",
asset_risk_calculated: "Anlagenrisiko berechnet",
asset_risk_assessment_persist_batch: "Anlagenrisiken gesammelt gespeichert",
recipe_run: "Automatisierungsrezept ausgeführt",
},
asset: {
extract_vin_or_serial: "FIN oder Seriennummer lesen",
generate_advanced_report: "Erweiterter Anlagenbericht",
improve_description: "Anlagenbeschreibung verbessern",
infer_identity: "Anlage identifizieren",
journey_summary: "Zusammenfassung des Anlagenverlaufs",
timeline_summary: "Zusammenfassung der Anlagen-Zeitleiste",
},
assistant: {
recommend_next_actions: "Nächste Schritte vom Assistenten",
},
connected: {
event_ingest: "Nachricht eines verbundenen Geräts",
},
document: {
extract_metadata: "Dokumentdetails lesen",
},
esg: {
  writeup: "ESG-Bericht",
},
home: {
operations_briefing: "Betriebsbriefing",
},
insights: {
recommend_next_actions: "Empfohlene nächste Schritte",
},
inspection: {
analyse_image: "Inspektionsfoto analysieren",
completed: "Inspektion abgeschlossen",
fix_recommendation: "Behebungsempfehlung",
generate_job_drafts: "Aufträge aus einer Inspektion entwerfen",
generate_summary: "Inspektionszusammenfassung",
improve_note: "Inspektionsnotiz verbessern",
},
job: {
completion_closeout: "Auftragsabschluss",
extract_invoice_line_items: "Rechnungspositionen lesen",
generate_invoice_draft: "Rechnungsentwurf",
improve_update_note: "Auftragsupdate verbessern",
suggest_certificate_draft: "Zertifikat vorschlagen",
suggest_completion_criteria: "Abschlusskriterien vorschlagen",
suggest_follow_up_job: "Folgeauftrag vorschlagen",
},
quote: {
compare_quotes: "Angebote vergleichen",
generate_rfq_scope: "Umfang der Angebotsanfrage entwerfen",
recommend_quote: "Angebot empfehlen",
summarize_quotes: "Angebote zusammenfassen",
},
request: {
polish_follow_up_draft: "Antwort auf Anfrage verfeinern",
},
site: {
generate_advanced_report: "Erweiterter Standortbericht",
},
template: {
generate_draft: "Checkliste entwerfen",
},
vision: {
analyse_group: "WRX Vision-Scan",
verify_completion: "WRX Verified-Nachweisprüfung",
},
work: {
analyse_evidence: "Arbeitsnachweise analysieren",
},
},
entityType: {
asset: "Anlage",
job: "Auftrag",
inspection: "Inspektion",
request: "Anfrage",
quote: "Angebot",
site: "Standort",
document: "Dokument",
template: "Checkliste",
contact: "Kontakt",
},
feedback: {
helpful: "Hilfreich",
not_helpful: "Nicht hilfreich",
},
action: {
refine: "Verfeinerung angefordert",
},
creditMode: {
none: "keine",
estimated: "geschätzt",
actual: "tatsächlich",
},
},
aiCapabilityDetail: {
kicker: "Funktionsdetails · 30 Tage",
closeA11y: "Detail schließen",
loading: "Details werden geladen…",
noFeedback: "Noch kein Feedback für diese Funktion.",
sectionFeedback: "Feedback-Aufschlüsselung",
sectionActionTaken: "Aktion durchgeführt",
sectionDailyActivity: "Tägliche Aktivität",
noActivity: "Keine Aktivität in diesem Zeitraum.",
sectionRecentEntities: "Aktuelle Entitäten",
totalLine_one: "{{count}} Ereignis insgesamt im Zeitraum.",
totalLine_other: "{{count}} Ereignisse insgesamt im Zeitraum.",
},
syncCenter: {
  errors: {
    unsupportedWrite: "Diese Änderung braucht eine neuere App-Version, um gesendet zu werden. Sie bleibt auf diesem Gerät gespeichert.",
    waitingOnFailedParent: "Wartet auf den Datensatz, zu dem es gehört und der nicht gesendet werden konnte. Korrigieren oder verwerfen Sie zuerst diesen Eintrag auf dieser Seite.",
    transientUnknown: "Diese Änderung wurde noch nicht gesendet. Es wird erneut versucht; wenden Sie sich an den Support, wenn das weiterhin passiert.",
    permanentUnknown: "Diese Änderung kann nicht automatisch übernommen werden. Prüfen oder verwerfen Sie sie.",
    serverError: "Der Server hatte ein Problem. Die Änderung wird erneut gesendet; wenden Sie sich an den Support, wenn das weiterhin passiert.",
    rateLimited: "Der Server ist ausgelastet. Die Änderung wird in Kürze erneut gesendet.",
    network: "Verbindungsproblem. Die Änderung wird automatisch gesendet, oder Sie versuchen es jetzt erneut.",
    conflict: "Eine neuere Version ist bereits gespeichert. Verwerfen Sie diese Änderung und prüfen Sie die neueste Version.",
    notFound: "Das, wofür diese Änderung gedacht war, wurde entfernt. Sie können sie verwerfen.",
    permission: "Sie haben keine Berechtigung, diese Änderung zu senden. Wenden Sie sich an einen Admin des Arbeitsbereichs.",
    blocked: "Diese Änderung ist auf diesem Gerät gespeichert, konnte aber nicht gesendet werden. Versuchen Sie es erneut oder verwerfen Sie sie.",
    authRetry: "Melden Sie sich erneut an, um diese Änderung zu senden. Sie ist auf diesem Gerät gespeichert.",
  },
pageTitle: "Nicht gesendete Änderungen",
pageSubtitle: "Auf diesem Gerät gespeicherte Änderungen, die noch gesendet werden müssen.",
healthTitle: "Zustand",
statusSectionTitle: "Status",
retryAll: "Jetzt senden",
queuedWritesSynced: "Alles ist gesendet",
lastSync: "Zuletzt gesendet {{age}}",
noSyncsYet: "Noch nichts gesendet",
queuedLabel: "Wartet auf Senden",
inFlightLabel: "Wird gesendet",
lastFlushLabel: "Zuletzt gesendet",
lastDurationLabel: "Letzte Dauer",
never: "Nie",
pendingWritesTitle: "Wartet auf Senden",
unsentAnswersTitle: "Prüfungsantworten auf diesem Gerät",
unsentAnswersBody: "Sie werden automatisch gesendet, sobald Sie online sind. Wurde die Prüfung anderswo geändert, öffnen Sie sie, um sie zu prüfen und zu senden.",
openInspection: "Prüfung öffnen",
queuedInspectionPhotos: "Prüfungsfotos, die auf den Upload warten: {{total}}",
recoveryNote_one: "Eine von einer früheren Version der App gespeicherte Änderung hat keinen erfassten Besitzer. Sie wurde aufbewahrt, statt der nächsten angemeldeten Person zugewiesen zu werden. Wenn diese Arbeit Ihnen gehört, übernehmen Sie sie, dann wird sie gesendet; andernfalls verwerfen Sie sie.",
recoveryNote_other: "{{count}} Änderungen, die von einer früheren Version der App gespeichert wurden, haben keinen erfassten Besitzer. Sie wurden aufbewahrt, statt der nächsten angemeldeten Person zugewiesen zu werden. Wenn diese Arbeit Ihnen gehört, übernehmen Sie sie, dann wird sie synchronisiert; andernfalls verwerfen Sie sie.",
claimAsMine: "Als meine übernehmen",
discard: "Verwerfen",
claimAllAsMine: "Alle als meine übernehmen",
discardAll: "Alles verwerfen",
noQueuedWritesTitle: "Nichts wartet auf Senden",
noQueuedWritesBody: "Änderungen auf diesem Gerät werden gesendet, sobald Sie online sind. Inspektionsfotos erscheinen bei ihrer Inspektion.",
hideTechnicalDetails: "Technische Details ausblenden",
showTechnicalDetails: "Technische Details anzeigen",
technicalDetail_one: "{{rawError}} · {{count}} Versuch",
technicalDetail_other: "{{rawError}} · {{count}} Versuche",
retry: "Wiederholen",
offlineSupportTitle: "Was ohne Verbindung funktioniert",
statusOnlineRequired: "Braucht eine Verbindung",
statusLocalDraft: "Zuerst auf diesem Gerät gespeichert",
policyEntity: {
Asset: "Anlage",
Inspection: "Inspektion",
Job: "Auftrag",
Schedule: "Planung",
Request: "Anfrage",
Comment: "Kommentar",
Media: "Medien",
},
policyAction: {
createAsset: "Anlage anlegen",
editAsset: "Anlage bearbeiten",
addDocument: "Dokument hinzufügen",
answerChecklistItems: "Checklistenpunkte beantworten",
startInspection: "Neue Prüfung starten",
submitInspection: "Prüfung pausieren, fortsetzen oder abschließen",
createJob: "Auftrag anlegen",
addJobPhotos: "Fotos beim Anlegen eines Auftrags hinzufügen",
postActivity: "Aktivitätsnotizen und Fotos posten",
moveJobStatus: "Auftrag annehmen, planen oder abzeichnen",
startPauseCompleteJob: "Auftrag starten, pausieren oder abschließen",
updateJobDetails: "Auftragsdetails aktualisieren",
scheduleInspection: "Inspektion planen",
answerCheck: "Prüfung beantworten",
recordMeterReading: "Zählerstand erfassen",
reportCantComplete: "Melden, dass die Arbeit nicht erledigt werden kann",
decideChangeRequest: "Über eine Änderungsanfrage entscheiden",
createOrRespondRequest: "Erstellen oder beantworten",
postComment: "Kommentar posten",
uploadEvidence: "Nachweise hochladen",
},
supportCopy: {
queued: "Lokal gespeichert, dann automatisch synchronisiert",
local_draft: "Bis zum Einreichen lokal gespeichert",
online_required: "Verbindung erforderlich",
},
conflictCopy: {
idempotent_replay: "Sichere Wiederholung: Derselbe Vorgang wird nicht doppelt ausgeführt.",
merge_review: "Wenn sich die Daten auf dem Server geändert haben, prüfen und zusammenführen, bevor gespeichert wird.",
latest_write: "Die zuletzt vom Server angenommene Änderung ist maßgeblich.",
},
entryAsset: "Neue Anlage",
entryInspectionJob: "Inspektionsarbeitsauftrag",
entryJob: "Neuer Arbeitsauftrag",
entryJobPhoto: "Arbeitsauftragsfoto",
entryJobUpdate: "Arbeitsauftragsaktualisierung",
entryScheduledInspection: "Geplante Inspektion",
entryAssetDocument: "Anlagendokument",
entryFieldMove: "Starten, Pause oder Abschluss",
entryNewInspection: "Neue Prüfung",
ageJustNow: "gerade eben",
ageMinutesAgo: "vor {{mins}} Min.",
ageHoursAgo: "vor {{hrs}} Std.",
ageDaysAgo: "vor {{days}} T.",
readErrorBody: "Gespeicherte Arbeit konnte nicht gelesen werden. Sie befindet sich noch auf diesem Gerät und wurde nicht verworfen.",
flushErrorBody: "Wir konnten Ihre Änderungen nicht senden. Sie sind weiterhin auf diesem Gerät gespeichert.",
claimErrorBody: "Diese Änderungen konnten nicht beansprucht werden. Sie werden weiterhin auf diesem Gerät gespeichert.",
discardManyErrorBody: "Diese Änderungen konnten nicht verworfen werden. Sie werden weiterhin auf diesem Gerät gespeichert.",
discardOneErrorBody: "Die Änderung konnte nicht verworfen werden. Sie ist weiterhin auf diesem Gerät gespeichert.",
},
trustCenter: {
pageTitle: "Vertrauenszentrum",
pageSubtitle: "Audit, Integrationen, Zugriff und Konformitätsstatus für diesen Arbeitsbereich.",
loading: "Wird geladen...",
auditLogTitle: "Audit-Protokoll",
auditLogDescription: "Wer hat was wann für alle Anlagen, Arbeitsaufträge, Inspektionen und Verwaltungsaktionen getan?",
auditLogEmptyTitle: "Audit-Protokoll noch nicht verfügbar",
auditLogEmptyBody: "Sobald der Audit-Feed für Ihren Arbeitsbereich aktiviert ist, wird jede relevante Aktion hier mit Akteur, Ziel und Zeitstempel angezeigt.",
integrationHealthTitle: "Integrationszustand",
integrationHealthDescription: "API + MCP + IoT-Connectors: Verbindungsstatus, letzte Synchronisierung, Fehlerrate.",
integrationHealthEmptyTitle: "Keine Integrationen verbunden",
integrationHealthEmptyBody: "Verbinden Sie eine Integration, um hier den Live-Zustand anzuzeigen – einschließlich der letzten erfolgreichen Synchronisierung, der Fehlerrate und des Wiederholungsstatus.",
webhookRetryTitle: "Webhook-Wiederholungsversuche",
webhookRetryDescription: "Ausgehende Webhook-Zustellungen, die fehlgeschlagen sind und erneut versucht wurden, mit Textkörpern und Antwortcodes.",
webhookRetryEmptyTitle: "Keine Webhook-Fehler",
webhookRetryEmptyBody: "Fehlgeschlagene Webhook-Zustellungen (mit ihrem Wiederholungsverlauf und Text) werden hier angezeigt, wenn sie auftreten.",
apiKeysTitle: "API-Schlüssel und Bereiche",
apiKeysDescription: "Ausgestellte Schlüssel, Bereiche, Rotationsstatus und wer sie erstellt hat.",
apiKeysEmptyTitle: "Keine API-Schlüssel ausgegeben",
apiKeysEmptyBody: "Wenn ein Arbeitsbereichsbesitzer einen API-Schlüssel erstellt, werden dessen Bereiche und Rotationsrhythmus hier gespeichert.",
rolesTitle: "Rollen und Berechtigungen",
rolesDescription: "Wer teamübergreifend was tun darf, mit effektiven Berechtigungen und Überschreibungen.",
rolesEmptyTitle: "Es wurden noch keine Rollenzuweisungen erfasst",
rolesEmptyBody: "Jeder Benutzer und jedes Team, die von ihnen gehaltenen Berechtigungen und etwaige Überschreibungen werden hier angezeigt.",
complianceTitle: "Konformitätslage",
complianceDescription: "SOC2/ISO-Bereitschaft, Datenresidenz, Aufbewahrung und Exportstatus.",
complianceEmptyTitle: "Es wurden noch keine Konformitätssignale aufgezeichnet",
complianceEmptyBody: "SOC2-/ISO-Bereitschaft, Datenresidenz, Aufbewahrung und Exportstatus werden hier angezeigt, während sie für diesen Arbeitsbereich aufgezeichnet werden.",
audit: {
byActor: "von {{name}}",
toRecipient: "an {{name}}",
action: {
asset: {
created: "Anlage angelegt",
updated: "Anlage aktualisiert",
shared: "Anlage geteilt",
share_revoked: "Anlagenfreigabe widerrufen",
},
inspection: {
created: "Inspektion angelegt",
started: "Inspektion begonnen",
completed: "Inspektion abgeschlossen",
failed_item_recorded: "Mangelpunkt erfasst",
approved: "Inspektion freigegeben",
reopened: "Inspektion wieder geöffnet",
shared: "Bericht geteilt",
share_approved: "Bericht genehmigt",
share_rejected: "Bericht abgelehnt",
},
job: {
created: "Auftrag angelegt",
assigned: "Auftrag zugewiesen",
started: "Auftrag begonnen",
completed: "Auftrag abgeschlossen",
reopened: "Auftrag wieder geöffnet",
verified: "Auftrag bestätigt",
},
document: {
created: "Dokument hinzugefügt",
renewed: "Dokument erneuert",
superseded: "Dokument ersetzt",
},
compliance: {
expiring_detected: "Ablaufende Konformität erkannt",
},
insight: {
generated: "Erkenntnis erstellt",
feedback_submitted: "Feedback zu einer Erkenntnis gesendet",
},
technician: {
assignment_recommended: "Zuständige Person empfohlen",
assignment_accepted: "Zuweisung angenommen",
},
condition: {
assessment_calculated: "Zustand bewertet",
recommendation_created: "Zustandsempfehlung erstellt",
recommendation_accepted: "Zustandsempfehlung angenommen",
recommendation_dismissed: "Zustandsempfehlung verworfen",
},
scheduling: {
recommendation_shown: "Planungsvorschlag angezeigt",
recommendation_selected: "Planungsvorschlag gewählt",
},
assistant: {
  change: "Über den Assistenten geändert",
  undo: "Über den Assistenten rückgängig gemacht",
},
},
entity: {
asset: "Anlage",
job: "Auftrag",
inspection: "Inspektion",
document: "Dokument",
asset_share: "Anlagenfreigabe",
inspection_share: "Berichtsfreigabe",
insight: "Erkenntnis",
compliance: "Konformität",
technician: "Zuweisung",
site: "Standort",
scheduled_inspection: "Geplante Inspektion",
template: "Checkliste",
asset_request: "Anfrage",
},
},
},
teamInvite: {
pageTitle: "Teameinladung",
invalidLink: "Ungültiger Einladungslink",
loadTimeout: "Das Laden der Einladung dauert zu lange. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
notFound: "Einladung nicht gefunden",
expiredMessage: "Ihre Einladung{{where}} ist{{when}} abgelaufen. Bitten Sie die Person, die Sie eingeladen hat, Ihnen eine neue zu schicken.",
expiredWhereSuffix: " für {{teamName}}",
expiredWhenSuffix: " am {{date}}",
loadFailed: "Die Einladung konnte nicht geladen werden",
emailMismatchTitle: "E-Mail-Konflikt",
emailMismatchBody: "Diese Einladung wurde an {{email}} gesendet. Bitte melden Sie sich mit dieser E-Mail-Adresse an, um zu akzeptieren.",
errorTitle: "Fehler",
linkSendFailedTitle: "Der Link konnte nicht gesendet werden",
linkSendFailedBody: "Bitte versuchen Sie es erneut oder bitten Sie denjenigen, der Sie eingeladen hat, die Einladung erneut zu senden.",
loadingInvitation: "Einladung wird geladen…",
invalidOrExpiredTitle: "Ungültig oder abgelaufen",
linkNoLongerValid: "Dieser Einladungslink ist nicht mehr gültig.",
tryAgain: "Erneut versuchen",
goToApp: "Gehen Sie zu AssetWRX",
cardTitle: "Teameinladung",
invitedPrefix: "Sie wurden eingeladen zu",
invitedRoleSuffix: "als {{role}}.",
checkEmailForLink: "Suchen Sie in {{email}} nach einem Anmeldelink. Er bringt Sie hierher zurück, um die Einladung anzunehmen.",
signInAsEmail: "Melden Sie sich als {{email}} an, um diese Einladung anzunehmen",
linkSent: "Link gesendet",
emailSignInLink: "Schicken Sie mir einen Anmeldelink per E-Mail",
signIn: "Anmelden",
wrongAccountHint: "Diese Einladung wurde an {{email}} gesendet. Melden Sie sich mit diesem Konto an.",
signInDifferentAccount: "Melden Sie sich mit einem anderen Konto an",
accept: "Annehmen",
decline: "Ablehnen",
},
logoOrInitials: {
logoA11y: "Workspace-Logo",
initialsA11y: "Workspace-Initialen",
},
shellTabsListA11y: "Bereiche der Workspace-Einstellungen",
teamManage: {
offerFailedTitle: "Angebot konnte nicht gesendet werden",
tryAgain: "Versuchen Sie es gleich noch einmal.",
offerSent: "{{name}} wurde gebeten, die Inhaberschaft anzunehmen. Bis dahin ändert sich nichts.",
linkCopied: "Einladungslink kopiert. Senden Sie ihn auf beliebigem Weg.",
inviteLinkTitle: "Einladungslink",
checkEmails: "Prüfen Sie {{emails}} und versuchen Sie es erneut.",
enterEmail: "Geben Sie mindestens eine E-Mail-Adresse ein.",
invitesSent_one: "Einladung an {{email}} gesendet. Die Person erhält eine E-Mail mit einem Beitrittslink und erscheint unter Mitglieder, sobald sie annimmt.",
invitesSent_other: "{{count}} Einladungen gesendet. Jede Person erhält eine E-Mail mit einem Beitrittslink und erscheint unter Mitglieder, sobald sie annimmt.",
undeliveredTitle: "Einladung gespeichert, E-Mail nicht gesendet",
undeliveredBody: "Wir konnten {{emails}} keine E-Mail senden. Tippen Sie auf Einladungslink kopieren und senden Sie ihn selbst.",
copyInviteLink: "Einladungslink kopieren",
ok: "OK",
joined: "Sie sind {{team}} beigetreten. Mit dem Team geteilte Arbeit erscheint jetzt auf der Startseite und unter Arbeit.",
joinFailedTitle: "Beitritt zum Team nicht möglich",
notNow: "Nicht jetzt",
declineTitle: "Einladung ablehnen?",
declineBody: "Einladung zu {{team}} ablehnen? Für einen späteren Beitritt brauchen Sie eine neue Einladung.",
declineFailedTitle: "Einladung konnte nicht abgelehnt werden",
created: "{{name}} ist bereit. Laden Sie Personen ein, damit sie die Anlagen und die Arbeit des Teams sehen.",
createFailedTitle: "Team konnte nicht erstellt werden",
createFailedBody: "Das Team konnte gerade nicht erstellt werden. Versuchen Sie es gleich noch einmal.",
switchedTo: "Sie arbeiten jetzt in {{team}}",
switchFailedTitle: "Team konnte nicht gewechselt werden",
switchToA11y: "Zu {{team}} wechseln",
personalHint: "Sie sind im persönlichen Bereich und sehen nur Ihre eigene Arbeit. Tippen Sie auf ein Team, um dorthin zu wechseln.",
tapToSwitchHint: "Tippen Sie auf ein Team, um dorthin zu wechseln. Anlagen und Arbeit wechseln zu denen dieses Teams.",
noTeamTitle: "Noch kein Team",
noTeamBody: "Erstellen Sie ein Team, um Anlagen und Arbeit mit Kollegen zu teilen. Danach können Sie Personen einladen.",
adoptAssets_one: "Ihre Anlage zu {{team}} hinzufügen. Im Moment sehen nur Sie sie.",
adoptAssets_other: "Ihre {{count}} Anlagen zu {{team}} hinzufügen. Im Moment sehen nur Sie sie.",
adoptFailedTitle: "Anlagen konnten nicht hinzugefügt werden",
membershipHint: "Personen, die Sie hier einladen, können sich anmelden und in diesem Team arbeiten. Um die Daten einer Person ohne Zugang zu speichern (z. B. Auftragnehmer oder Mieter), legen Sie sie unter Kontakte an.",
emailPlaceholder: "alex@example.com\nsam@example.com",
inviteAsA11y: "Als {{role}} einladen",
roleDescription: {
member: "Aufträge, Inspektionen und Anfragen erledigen und aktualisieren.",
admin: "Personen einladen und entfernen und Teameinstellungen ändern.",
},
sendInvite_one: "Einladung senden",
sendInvite_other: "{{count}} Einladungen senden",
inviteExpired: "Abgelaufen am {{date}}. Tippen Sie auf Erneut senden, um erneut einzuladen.",
inviteSentOn: "Gesendet am {{date}}",
resendFailedTitle: "Einladung konnte nicht erneut gesendet werden",
resent: "Einladung erneut an {{email}} gesendet.",
resendA11y: "Einladung erneut an {{email}} senden",
cancelInviteA11y: "Einladung für {{email}} zurückziehen",
cancelInviteFailedTitle: "Einladung konnte nicht zurückgezogen werden",
cancelInviteConfirmTitle: "Diese Einladung zurückziehen?",
cancelInviteConfirmBody: "Falls {{email}} den Link bereits hat, funktioniert er danach nicht mehr.",
cancelInviteConfirm: "Einladung zurückziehen",
membersTitle: "Mitglieder · {{n}}",
mfaPending: "{{n}} noch einzurichten",
mfaAllCovered: "Alle sind geschützt",
mfaSocialExempt: "{{n}} melden sich mit Google oder Apple an (nicht nötig)",
mfaOnA11y: "{{name}} hat die Zwei-Faktor-Authentifizierung aktiviert",
mfaOffA11y: "{{name}} hat keine Zwei-Faktor-Authentifizierung",
moreActionsA11y: "Weitere Aktionen für {{name}}",
yourSkills: "Ihre Fähigkeiten",
memberSkills: "Fähigkeiten von {{name}}",
skillsSaveFailedTitle: "Fähigkeiten konnten nicht gespeichert werden",
skillsSaveFailedBody: "Es wurde nichts geändert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
saveSkills: "Fähigkeiten speichern",
transferBody: "{{name}} die Team-Inhaberschaft anbieten? Die Person muss annehmen, bevor sich etwas ändert; danach werden Sie Admin.",
sendOffer: "Angebot senden",
resetMfaBody: "Die Zwei-Faktor-Einrichtung von {{name}} löschen? Bei der nächsten Anmeldung wird die Person gebeten, erneut eine Authenticator-App einzurichten. Nutzen Sie dies, wenn jemand sein Telefon verloren hat.",
reset: "Zurücksetzen",
resetMfaDoneTitle: "Zwei-Faktor zurückgesetzt",
resetMfaDone: "{{name}} kann die Zwei-Faktor-Authentifizierung bei der nächsten Anmeldung neu einrichten.",
resetMfaNothing: "{{name}} hatte keine Zwei-Faktor-Authentifizierung. Nichts zurückzusetzen.",
resetFailedTitle: "Zwei-Faktor konnte nicht zurückgesetzt werden",
removeBody: "{{name}} aus dem Team entfernen?",
removeBodyWithJobs_one: "{{name}} aus dem Team entfernen? {{count}} offener Auftrag bleibt der Person zugewiesen, bis Sie ihn neu zuweisen.",
removeBodyWithJobs_other: "{{name}} aus dem Team entfernen? {{count}} offene Aufträge bleiben der Person zugewiesen, bis Sie sie neu zuweisen.",
remove: "Entfernen",
leaveBody: "{{team}} verlassen? Für einen erneuten Beitritt brauchen Sie eine neue Einladung.",
leave: "Verlassen",
leaveFailedTitle: "Team konnte nicht verlassen werden",
deleteBody: "{{team}} löschen? Seine Anlagen, Inspektionen und Aufträge gehen an Ihr Konto zurück. Das kann nicht rückgängig gemacht werden.",
delete: "Löschen",
deleteFailedTitle: "Team konnte nicht gelöscht werden",
renameFailedTitle: "Team konnte nicht umbenannt werden",
theMember: "Das Mitglied",
noMemberMatches: "Kein Mitglied gefunden.",
defaults: {
companyTitle: "Standardeinstellungen des Unternehmens",
companyHint: "Sie gelten im ganzen Unternehmen. Sie können sie auch unter Konto → Einstellungen ändern.",
teamTitle: "Einstellungen dieses Teams",
teamHint: "Verwenden Sie die Standardeinstellungen des Unternehmens oder legen Sie für dieses Team andere fest.",
teamCurrency: "Teamwährung",
teamSharing: "Wie dieses Team Arbeit teilt",
sameAsCompany: "Wie im Unternehmen",
setForTeam: "Für dieses Team festlegen",
inUse: "Gilt für dieses Team",
},
errors: {
teamNotFound: "Dieses Team wurde nicht gefunden. Gehen Sie zurück und öffnen Sie es erneut.",
inviteNotFound: "Diese Einladung wurde nicht gefunden oder ist abgelaufen.",
invite: "Einladung konnte nicht gesendet werden. Versuchen Sie es gleich noch einmal.",
resend: "Einladung konnte nicht erneut gesendet werden. Versuchen Sie es gleich noch einmal.",
accept: "Beitritt zum Team nicht möglich. Prüfen Sie, ob die Einladung noch gültig ist und Sie mit der E-Mail-Adresse angemeldet sind, an die sie ging.",
deleteTeam: "Team konnte nicht gelöscht werden. Versuchen Sie es gleich noch einmal.",
onlyOwnerDelete: "Nur der Teaminhaber kann das Team löschen.",
transfer: "Angebot konnte nicht gesendet werden. Versuchen Sie es gleich noch einmal.",
acceptTransfer: "Inhaberschaft konnte nicht angenommen werden. Versuchen Sie es gleich noch einmal.",
declineTransfer: "Angebot konnte nicht abgelehnt werden. Versuchen Sie es gleich noch einmal.",
cancelTransfer: "Angebot konnte nicht zurückgezogen werden. Versuchen Sie es gleich noch einmal.",
promote: "Die Person konnte nicht zum Inhaber gemacht werden. Versuchen Sie es gleich noch einmal.",
demote: "Die Rolle konnte nicht geändert werden. Versuchen Sie es gleich noch einmal.",
alreadyMember: "Diese Person ist bereits im Team.",
alreadyInvited: "An diese E-Mail-Adresse wurde bereits eine Einladung gesendet.",
noAccount: "Ihr Workspace wird noch eingerichtet. Warten Sie einen Moment und versuchen Sie es erneut.",
},
},
featuresScreen: {
  lockedRowA11y: "{{feature}}, durch den Tarif gesperrt. Öffnet die Tarife, die sie enthalten.",
  statusNotYet: "Noch nicht verfügbar",
  title: "Funktionen",
  subtitle: "Was in diesem Arbeitsbereich aktiv ist. Tippen Sie auf eine durch den Tarif gesperrte Funktion, um die Tarife zu sehen, die sie enthalten.",
  simplePresetTitle: "Einfaches Preset",
  simplePresetBody: "Der Grundumfang für ein kleines Team: Anlagen, Standorte, Anfragen, Prüfungen, Aufträge, Freigaben, Berichte, Kontakte und Wartungspläne. Insights, Auftragnehmer, Teams, Integrationen, KI und Entwicklerwerkzeuge werden ausgeschaltet und sind hier jeweils einen Schalter entfernt.",
  simplePresetButton: "Einfaches Preset verwenden",
  simplePresetConfirm: "Insights, Auftragnehmer, Teams, Integrationen, KI und Entwickler für diesen Arbeitsbereich ausschalten? Jedes bleibt einen Schalter entfernt.",
  simplePresetApplied: "Auf das einfache Preset umgestellt.",
  switchA11y: "{{feature}}: für diesen Arbeitsbereich ein- oder ausschalten",
  switchFailed: "Die Änderung wurde nicht gespeichert. Verbindung prüfen und erneut versuchen.",
  adminHint: "Inhaber und Admins schalten Funktionen hier um; alle anderen sehen, was aktiv ist.",
  statusEnabled: "Aktiv",
  statusDisabled: "Inaktiv",
  statusLockedPlan: "Durch Tarif gesperrt",
  statusRestrictedRole: "Durch Rolle eingeschränkt",
  statusDisabledAdmin: "Für diesen Arbeitsbereich aus",
  statusBeta: "Beta",
  statusDependency: "Benötigt eine andere Funktion",
  statusUnavailable: "Nicht verfügbar",
  statusSetByAssetwrxOn: "An, von AssetWRX eingestellt",
  statusSetByAssetwrxOff: "Aus, von AssetWRX eingestellt",
  statusLoading: "Wird geprüft…",
  modules: "Module",
  capabilities: "Funktionen",
  empty: "Noch keine Funktionen anzuzeigen.",
  planLabel: "Tarif: {{plan}}",
  planUngated: "Tarif: ohne Einschränkungen",
},
featureCatalog: {
modules: {
assets: { title: "Anlagen" },
sites: { title: "Standorte" },
requests: { title: "Anfragen" },
inspections: { title: "Inspektionen" },
jobs: { title: "Aufträge" },
reviews: { title: "Prüfungen" },
reports: { title: "Berichte" },
analytics: { title: "Analysen" },
contacts: { title: "Kontakte" },
contractors: { title: "Auftragnehmer" },
teams: { title: "Teamverwaltung" },
automation: { title: "Automatisierung" },
integrations: { title: "Integrationen" },
ai: { title: "KI" },
administration: { title: "Verwaltung" },
settings: { title: "Einstellungen" },
developer: { title: "Entwickler" },
},
capabilities: {
  asset_360: { title: "Asset 360", description: "Der Asset-360-Bericht: Gesamturteil, Kennzahlen, Abschnitte für den gewählten Leser, Maßnahmenplan und Datenqualität, mit KI-Fassung auf Wunsch." },
  site_360: { title: "Site 360", description: "Der Site-360-Bericht: der ganze Standort mit Gebäuden und Bereichen, Compliance, Risiko, Arbeit und Auftragnehmern, mit KI-Fassung auf Wunsch." },
  esg: { title: "ESG und Nachhaltigkeit", description: "Energie, CO₂, Energieausweise und F-Gas-Kältemittel für Standorte und Anlagen, mit Portfolioansicht und ESG-Kapitel in Site 360 und Asset 360. Ein kostenpflichtiges Add-on." },
  esg_ai_writeup: { title: "ESG-KI-Bericht", description: "Eine schriftliche ESG-Zusammenfassung mit Maßnahmenvorschlägen, von der KI aus den ESG-Zahlen erstellt. Verbraucht Credits." },
group_rules: { title: "Gruppenregeln", description: "Regeln, die dieselbe Checkliste für jede passende Anlage planen und sie auch für später hinzugefügte Anlagen beibehalten." },
rounds: { title: "Rundgänge", description: "Ein Auftrag, der eine Checkliste der Reihe nach über mehrere Anlagen führt." },
contractor_inspections: { title: "Prüfungen durch Auftragnehmer", description: "Eine Prüfung an einen Auftragnehmer mit AssetWRX-Konto geben; sie erscheint in seiner Arbeit und er führt sie mit derselben Checkliste durch." },
sub_jobs: { title: "Teilaufträge", description: "Ein Auftrag kann Teilaufträge haben, jeder mit eigener Person oder eigenem Auftragnehmer, Datum, Prüfungen und Kosten; der Hauptauftrag wartet auf sie." },
custom_asset_types: { title: "Eigene Anlagentypen und Felder", description: "Eigene Anlagentypen mit eigenen Feldern, über Ort, Ausrüstung, Fahrzeug und Sonstiges hinaus." },
bulk_asset_setup: { title: "Massenerstellung und Gebäudevorlagen", description: "Viele Orte oder Anlagen auf einmal anlegen oder ein ganzes Gebäude aus einer Gebäudevorlage." },
contact_import: { title: "Kontaktimport", description: "Kontakte aus dem Adressbuch des Telefons oder aus einer Datei importieren." },
ai_checklist_generation: { title: "KI-Checklistenerstellung", description: "Eine Checkliste mit KI aus einer Beschreibung, einem Foto oder einem Dokument entwerfen." },
assistant_changes: { title: "Assistent darf Datensätze ändern", description: "Der Assistent bereitet neue und geänderte Anlagen, Standorte, Inspektionen, Aufträge und Gruppenregeln vor, die eine Person bestätigt." },
assistant_planning: { title: "Assistent: Planung und Optimierung", description: "Der Assistent plant Tage, verteilt die Arbeitslast, schlägt Zeiten vor und berät zu Wartungsprogrammen." },
assistant_insights: { title: "Assistent: Einblicke und Briefings", description: "Der Assistent erklärt Trends, Kosten und Ursachen, erstellt Berichte und gibt ein wöchentliches Briefing." },
assistant_photo: { title: "Assistent: Fragen zu Fotos", description: "Den Assistenten zu einem Foto fragen, das Sie aufnehmen oder auswählen." },
assistant_voice: { title: "Assistent: Sprache", description: "Mit dem Assistenten sprechen und seine Antworten hören (erfordert die neueste App aus dem Store)." },
feature_requests: { title: "Funktionswünsche", description: "Eine Funktion anfragen, Ihre Anfragen verfolgen und über Ideen abstimmen, die wir prüfen." },
qr_codes: { title: "QR-Codes", description: "QR-Codes zur Identifizierung von Anlagen erzeugen und scannen." },
barcode_scan: { title: "Barcode-Scan", description: "Barcodes scannen, um Anlagenkennungen nachzuschlagen oder zu erfassen." },
condition_intelligence: { title: "Zustandsanalyse", description: "Regelbasierter Anlagenzustand, Risikoempfehlungen und Eignung der Techniker an der Anlage und im Planer." },
location_tracking: { title: "Standortverfolgung", description: "Standortverlauf der Anlage und die Standortangaben aus Inspektionen, Aufträgen und verbundenen Quellen." },
knowledge_base: { title: "Wissensdatenbank", description: "Anleitungen, FAQs, Notizen und Dateien zu einer Anlage, die anlagenübergreifende Wissenssuche und Freigabelinks ohne Anmeldung." },
approvals: { title: "Genehmigungen", description: "Genehmigungs- und Triage-Abläufe für Anfragen und Abschlüsse." },
photo_capture: { title: "Fotoaufnahme", description: "Fotos als Nachweis in Inspektionen, Aufträgen und Anfragen aufnehmen." },
video_capture: { title: "Videoaufnahme", description: "Kurze Videos als Nachweis anhängen." },
drawing: { title: "Zeichnen / Markieren", description: "Fotos mit Zeichnungen und Hinweisen versehen." },
voice_dictation: { title: "Sprachdiktat", description: "Notizen und Feldinhalte per Sprache diktieren." },
speech_recognition: { title: "Spracherkennung", description: "Sprache-zu-Text auf dem Gerät als Grundlage für das Sprachdiktat." },
ml_kit: { description: "Bausteine für maschinelles Lernen auf dem Gerät (Bezeichnungen, Barcodes, Text)." },
evidence_intelligence: { title: "Nachweisanalyse", description: "Arbeitsnachweise lokal analysieren und nur bei Bedarf an die KI übergeben." },
wrx_vision: { description: "Eine Inspektionsgruppe oder einen Punkt scannen; Zähler, Kennungen und Barcodes werden auf dem Gerät gelesen, und Vorschläge werden geprüft, bevor etwas gespeichert wird." },
wrx_vision_cloud: { title: "WRX Vision Cloud-Analyse", description: "Cloud-Analyse eines Vision-Scans: Zustand, Mängel und nicht beobachtete Prüfungen anhand der Checklistenkriterien." },
wrx_vision_pack_fleet: { title: "WRX Vision Flottenpaket", description: "Fahrzeugschadensprüfungen: Dellen, Kratzer, Verglasung, Beleuchtung, Reifen und Räder." },
wrx_vision_pack_equipment: { title: "WRX Vision Ausrüstungspaket", description: "Prüfungen von Maschinen und Ausrüstung: Schutzvorrichtungen, Lecks, Schläuche, Kabel, Korrosion, Typenschilder und Zähler." },
wrx_vision_pack_property: { title: "WRX Vision Immobilienpaket", description: "Prüfungen von Räumen und Gebäuden: Feuchtigkeit, schimmelähnlicher Befall, Risse, Verglasung, Ausstattung und Zugang." },
wrx_vision_pack_safety: { title: "WRX Vision Paket Sicherheitsausrüstung", description: "Visuelle Prüfungen der Sicherheitsausrüstung: Feuerlöscher, Melder, Beschilderung und Zugang. Stellt nie ein Zertifikat aus." },
wrx_vision_training_share: { title: "WRX Vision Verbesserungsdaten", description: "Standardmäßig aktiviert: Die Nachweisfotos hinter geprüften Vision-Vorschlägen werden zur Verbesserung von Vision verwendet. Der Inhaber des Arbeitsbereichs kann dies deaktivieren." },
wrx_verified: { description: "Abschlussnachweise für Aufträge: erwartete Ergebnisse, Vorher-Nachher-Fotos und eine Nachweisprüfung, über die der Prüfer entscheidet." },
work_intelligence: { title: "Arbeitsanalyse", description: "Gemeinsame Analyse von Arbeitsnachweisen über alle Abläufe hinweg." },
work_planning: { description: "Planen, wer was wann und in welcher Reihenfolge erledigt: Personen-Zeit-Kalender, Kapazität, Anfahrt, Teile- und Qualifikationsbereitschaft sowie vorgeschlagene Pläne, die eine Person übernimmt." },
schedule_exceptions: { title: "Steuerung geplanter Arbeit", description: "Anfragen aus dem Feld, geplante Arbeit auszulassen, zu verschieben oder neu zuzuweisen, und die Entscheidungen darüber." },
compliance_register: { title: "Konformitätsregister", description: "Arbeitsbereichsweites Register für Zertifikate, Verlängerungen und überfällige Nachweise." },
journey_intelligence: { title: "KI-Ablaufanalyse", description: "KI-gestützte Erläuterungen und Erkenntnisse zu betrieblichen Abläufen." },
journey_analytics: { title: "Ablaufanalysen", description: "Dashboards und Trichter zu Abläufen im gesamten Bestand." },
power_bi_export: { title: "Power-BI-Export", description: "Analysedatensätze für Power BI exportieren." },
quotes: { title: "Angebote", description: "Angebote von Auftragnehmern anfordern, vergleichen und auswählen." },
scheduling: { title: "Terminplanung", description: "Kalenderplanung und geplante Arbeit." },
recurring_work: { title: "Wiederkehrende Arbeit", description: "Wiederkehrende Inspektionen und Pläne für vorbeugende Wartung." },
maintenance_programmes: { title: "Wartungsprogramme", description: "Mehrstufige Wartungsprogramme nach Zählerstand, Kalender und in fester Reihenfolge." },
csv_import: { title: "CSV-Import", description: "Kontakte und Anlagen aus CSV importieren." },
excel_import: { title: "Excel-Import", description: "Strukturierte Daten aus Excel-Arbeitsmappen importieren." },
power_automate: { description: "Power-Automate-Flows durch Plattformereignisse auslösen." },
iot_connectors: { title: "IoT-Konnektoren", description: "IoT-Signale empfangen, um Arbeit auszulösen." },
embed: { title: "Eingebettetes AssetWRX", description: "Ausgewählte AssetWRX-Ansichten (Arbeit, Anlagen, Inspektionen, Aufträge, Berichte) in einem anderen Portal ausführen, ohne die Oberfläche der AssetWRX-App." },
embed_interactive: { title: "Interaktive Einbettungen", description: "Eingebettete AssetWRX-Ansichten dürfen Anlagen aktualisieren, Inspektionen durchführen und Aufträge ändern, nicht nur anzeigen." },
ai_summary: { title: "KI-Zusammenfassung", description: "KI-generierte Zusammenfassungen und Entwürfe in allen Bereichen." },
ai_assistants: { title: "KI-Assistenten", description: "Interaktive KI-Assistenten und Copiloten." },
field_ai_assist: { title: "KI-Hilfe im Feld", description: "Diktieren, verbessern und zusammenfassen direkt im Textfeld, wo gearbeitet wird." },
industry_packs: { title: "Branchenpakete", description: "Kuratierte Pakete mit Checklisten und Wartungsplänen installieren, mit Paketvorschlägen pro Anlage." },
offline_mode: { title: "Offlinemodus", description: "Offline arbeiten mit automatischer Synchronisierung bei erneuter Verbindung." },
notifications: { title: "Benachrichtigungen", description: "In-App-, Push- und E-Mail-Benachrichtigungen." },
rest_api: { description: "Zugriff auf die eigene REST API." },
graphql: { description: "Zugriff auf die GraphQL API." },
webhooks: { title: "Ausgehende Webhooks", description: "Signierte ausgehende Webhooks abonnieren." },
mcp: { description: "Zugriff über das Model Context Protocol für agentenbasierte Integrationen." },
},
},
shellTabs: {
industryPacks: "Branchenpakete",
assetTypes: "Anlagentypen",
features: "Funktionen",
overview: "Übersicht",
organization: "Organisation",
defaults: "Standards",
teams: "Arbeitsteams",
reports: "Berichts-Branding",
integration: "Integrationen",
},
integrationHub: {
  ownerOnly: "Nur der Workspace-Inhaber, {{owner}}, kann Integrationen, API-Schlüssel und KI-Zugriff einrichten. Sie sehen, was verbunden ist; bitten Sie {{owner}}, Neues einzurichten.",
  ownerOnlyUnnamed: "Nur der Workspace-Inhaber kann Integrationen, API-Schlüssel und KI-Zugriff einrichten. Sie sehen, was verbunden ist; bitten Sie den Inhaber, Neues einzurichten.",
askOwnerSetup: "Bitten Sie {{owner}}, dies einzurichten.",
askOwnerSetupUnnamed: "Bitten Sie den Workspace-Inhaber, dies einzurichten.",
tryAgainShortly: "Versuchen Sie es gleich noch einmal.",
loadOfflineHint: "Prüfen Sie, ob dieses Gerät online ist, und versuchen Sie es dann erneut.",
conditionInvalidTitle: "Bedingung prüfen",
conditionInvalidBody: "Geben Sie eine Liste in eckigen Klammern ein, zum Beispiel [\"Offen\", \"Überfällig\"].",
recipeDraftCreated: "Rezeptentwurf gespeichert. Schalten Sie ihn ein, wenn Sie so weit sind.",
retryQueued: "Neuer Versuch gestartet. Das Ergebnis erscheint im Ausführungsverlauf.",
importRowFailed: "Zeile {{row}} konnte nicht gespeichert werden. Prüfen Sie die Werte dieser Zeile.",
importCustomTypeUnknown: "Zeile {{row}}: Kein Anlagentyp „{{name}}“ für diese Art, daher ohne Typ gespeichert.",
importSitsInMissing: "Zeile {{row}}: „{{name}}“ wurde nicht gefunden. Gespeichert, aber in nichts enthalten.",
importSitsInNotAllowed: "Zeile {{row}}: Kann sich nicht in „{{name}}“ befinden (ein Ort nur in einem Ort, ein Fahrzeug in nichts). Gespeichert, aber in nichts enthalten.",
importFileUnreadableTitle: "Datei konnte nicht gelesen werden",
importFileUnreadable: "Speichern Sie sie als CSV- oder Excel-Datei und wählen Sie sie erneut aus.",
importFailed: "Der Import wurde angehalten. Prüfen Sie Ihre Datei und wählen Sie dann Import wiederholen.",
apiErrors: {
sessionExpired: "Ihre Sitzung ist nicht mehr gültig. Melden Sie sich erneut an und versuchen Sie es dann noch einmal.",
ownerOnly: "Nur der Workspace-Inhaber kann Integrationen, API-Schlüssel und KI-Zugriff einrichten. Bitten Sie ihn, dies zu tun.",
forbidden: "Sie haben keine Berechtigung dafür.",
sourceInactive: "Diese verbundene Quelle ist nicht aktiv. Aktivieren Sie sie wieder oder erneuern Sie das Token, bevor Sie es erneut versuchen.",
mcpAuth: "Die KI-Verbindung konnte sich nicht anmelden. Prüfen Sie ihren Schlüssel und versuchen Sie es erneut.",
mcpUnreachable: "Der MCP-Server ist nicht erreichbar. Prüfen Sie URL, Zugangsdaten und Netzwerkzugang und versuchen Sie es erneut.",
sourceToken: "Dieses Datenquellen-Token ist für diesen Workspace nicht gültig.",
mcpRuntime: "Die KI-Verbindung konnte nicht abgeschlossen werden. Prüfen Sie Adresse und Schlüssel und versuchen Sie es erneut.",
mcpAdmin: "Die KI-Verbindung konnte nicht aktualisiert werden. Prüfen Sie die Angaben und versuchen Sie es erneut.",
automationRun: "Test oder Wiederholung der Automatisierung konnte nicht abgeschlossen werden. Prüfen Sie die Konfiguration und versuchen Sie es erneut.",
automationAdmin: "Die Automatisierung konnte nicht gespeichert werden. Prüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
connectedIngest: "Die Gerätenachricht wurde nicht angenommen. Prüfen Sie das Token und die gesendeten Anlagenreferenzen und versuchen Sie es erneut.",
connectedAdmin: "Diese Datenquelle konnte nicht aktualisiert werden. Prüfen Sie Quelle, Regel oder Nachricht und versuchen Sie es erneut.",
workspaceAdmin: "Diese Einstellung konnte nicht gespeichert werden. Versuchen Sie es erneut oder fragen Sie den Workspace-Inhaber.",
generic: "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
},
  importRetry: "Import wiederholen",
  importExcelFeature: "Excel-Import",
  importRetrying: "Wird wiederholt…",
  importStopped: "Bei Zeile {{row}} angehalten: {{message}} Diese Zeile und alle folgenden wurden nicht importiert.",
  importWizard: {
  step: {
  file: "Datei",
  object: "Objekt",
  map: "Zuordnung",
  preview: "Vorschau",
  done: "Fertig",
  },
  skip: "— Überspringen —",
  noDefault: "— Kein Standardwert —",
  optionalDefault: "Optionaler Standardwert…",
  sampleLeadDownload: "Neu beim Import? Laden Sie ein fertiges Beispiel herunter (gültige Spalten und Werte).",
  sampleLeadCopy: "Neu beim Import? Kopieren Sie ein fertiges Beispiel (gültige Spalten und Werte).",
  sampleAssetsDownload: "Anlagenbeispiel herunterladen",
  sampleAssetsCopy: "Anlagenbeispiel kopieren",
  sampleContactsDownload: "Kontaktbeispiel herunterladen",
  sampleContactsCopy: "Kontaktbeispiel kopieren",
  sampleAssetsA11yDownload: "Beispiel-CSV für den Anlagenimport herunterladen",
  sampleAssetsA11yCopy: "Beispiel-CSV für den Anlagenimport kopieren",
  sampleContactsA11yDownload: "Beispiel-CSV für den Kontaktimport herunterladen",
  sampleContactsA11yCopy: "Beispiel-CSV für den Kontaktimport kopieren",
  sampleCalloutDownload: "Beispieltabellen: Laden Sie die Beispieldateien aus Schritt 1 oder unten herunter.",
  sampleCalloutCopy: "Beispieltabellen: Kopieren Sie die Beispieldateien aus Schritt 1 oder unten.",
  formatReferenceShow: "Vollständige Datenformat-Referenz anzeigen",
  formatReferenceHide: "Vollständige Datenformat-Referenz ausblenden",
  },
webhookSecretIssued: "Neuer Webhook-Schlüssel ausgestellt. Kopieren Sie ihn jetzt — er wird nicht erneut angezeigt.",
webhookSecretReveal: "Anzeigen",
webhookSecretHide: "Ausblenden",
webhookSecretCopy: "Kopieren",
webhookSecretCopied: "Kopiert",
webhookSecretDismiss: "Schließen",
webhookSecretHiddenA11y: "Webhook-Schlüssel, ausgeblendet. Verwenden Sie „Anzeigen“, um ihn einzublenden.",
webhookSecretRevealedA11y: "Webhook-Schlüssel, auf dem Bildschirm sichtbar.",
breadcrumb: "Konto · Arbeitsbereich · Integrationen",
breadcrumbShort: "Workspace · Integrationen",
titleShort: "Integrations-Center",
hintShow: "Tab-Tipps",
hintHide: "Tipps ausblenden",
eyebrow: "Workspace-Integrationen",
title: "Unternehmenstaugliche Integrationen",
metaLine: "Verbinden Sie Ihre Geschäftstools mit API-Schlüsseln, Webhooks und einfachen Automatisierungen.",
contextHintApis: "APIs zuerst: Erstellen Sie sichere Schlüssel, prüfen Sie Berechtigungen und öffnen Sie die Live-API-Referenz.",
contextHintApisGateway: "API-Schlüssel & Zugriff: Verwaltung nutzt Ihre angemeldete Sitzung über das Workspace-Gateway. Schlüssel Schritt für Schritt anlegen, Verbindung prüfen, dann die Live-Referenz öffnen.",
contextHintMcp: "Workspace-MCP: Registrieren Sie genehmigte externe Server, verschlüsseln Sie Zugangsdaten, ermitteln Sie Metadaten und behalten Sie den Aufrufverlauf prüfbar.",
contextHintImport: "Datenimport: Laden Sie Tabellen hoch und ordnen Sie Ihre Datensätze schnell zu.",
contextHintAutomations: "Ereignis-Trigger: Rezepte und Verlauf. Dienstkonten und API-Schlüssel legen Sie unter „API-Schlüssel & Zugriff“ an – nicht hier.",
contextHintConnected: "Connected Ingestion ist ein eigener Tab: Erstellen Sie Quellen, rotieren Sie quellenspezifische Tokens, prüfen Sie eingehende Ereignisse und ungelöste Zuordnungen und verknüpfen Sie dann Regeln. Verwenden Sie „API-Schlüssel & Zugriff“ nur, wenn Sie ein Workspace-Dienstkonto statt des Ingest-Tokens möchten.",
contextHintConnectedShort: "Erstellen Sie eine Quelle, kopieren Sie das einmalige Token aus dem Popup, senden Sie JSON per POST an die Ingest-URL und fügen Sie optional Regeln hinzu. Dienstkonto-Schlüssel finden Sie unter „API-Schlüssel & Zugriff“.",
connectedAssetsLink: "Verbundene Anlagen",
resourcesHelp: "API-Referenz (in der App)",
mainTabImport: "Datenimport",
mainTabAutomations: "Ereignis-Trigger",
mainTabApisAccess: "API-Schlüssel & Zugriff",
mainTabMcp: "MCP-Server",
mainTabConnected: "Connected Ingestion",
guidedCategory: {
workflow: "Alltägliche Abläufe",
inspection: "Ein anderes System über Inspektionen informieren",
job: "Ein anderes System über Aufträge informieren",
asset_sync: "Anlagensynchronisierung",
inbound_webhook: "Von einem anderen System empfangen",
scheduled: "Nach Zeitplan",
outbound: "Testen",
},
journey: {
stage_choose: "Auswählen",
stage_configure: "Konfigurieren",
stage_authorise: "Autorisieren",
stage_mapping: "Zuordnen",
stage_preview: "Vorschau",
stage_test: "Testen",
stage_activate: "Aktivieren",
stage_monitor: "Überwachen",
stepCounter: "Schritt {{current}} von {{total}}",
back: "Zurück",
next: "Weiter",
finish: "Fertig",
close: "Schließen",
loading: "Wird geladen…",
testing: "Wird ausgeführt…",
succeeded: "Erfolg",
failed: "Fehlgeschlagen",
requestId: "Anfrage-ID",
retry: "Erneut versuchen",
nameLabel: "Verbindungsname",
outcome_read: "Daten aus AssetWRX lesen",
outcome_read_desc: "Das andere System ruft Anlagen, Prüfungen oder Aufträge aus AssetWRX ab.",
outcome_send: "Daten an AssetWRX senden",
outcome_send_desc: "Das andere System erstellt oder aktualisiert Datensätze in AssetWRX.",
outcome_listen: "Ereignisse von AssetWRX empfangen",
outcome_listen_desc: "AssetWRX benachrichtigt das andere System bei Änderungen.",
outcome_combination: "Eine Kombination",
outcome_combination_desc: "Bidirektional — lesen, schreiben und synchron bleiben.",
createAccess: "Sicheren Zugriff erstellen",
accessCreated: "Sicherer Zugriff erstellt",
accessFailed: "Sicherer Zugriff konnte nicht erstellt werden",
keyExpiryLabel: "Ablauf des Schlüssels",
keyExpiry30: "30 Tage",
keyExpiry90: "90 Tage",
keyExpiry365: "1 Jahr",
keyExpiryNever: "Nie",
apiKeyLabel: "API-Schlüssel",
customScopesHint: "Aktivieren Sie nur die Zugriffsrechte, die diese Verbindung benötigt.",
elevatedScopeHelp: "Benötigen Sie uneingeschränkten Zugriff? Prüfen und erstellen Sie ihn in der erweiterten Konsole.",
matchField: "Datensatzabgleich",
matchExternalId: "Anlagen anhand der externen ID abgleichen",
idempotencyPolicy: "Wiederholte Quellereignisse verwenden dieselbe Quellereignis-ID, sodass Wiederholungen keine doppelten Arbeiten erzeugen.",
conflictPolicy: "Wenn beide Systeme einen Datensatz geändert haben",
conflictPolicyNote: "Ihr IT-Team baut diese Regel in die Synchronisierung ein; AssetWRX zeigt sie ihm auf der Verbindungsseite. Um Duplikate zu vermeiden, sucht die Synchronisierung jede Anlage vor dem Anlegen über ihre externe ID.",
conflict_manual_review: "Eine Person fragen",
conflict_manual_review_desc: "Am sichersten. Ihr System überschreibt keinen Datensatz, der in AssetWRX geändert wurde, sondern markiert ihn zur Prüfung.",
conflict_source_wins: "Ihr System hat Vorrang",
conflict_source_wins_desc: "Ihr System aktualisiert den AssetWRX-Datensatz mit derselben externen ID.",
conflict_assetwrx_wins: "AssetWRX hat Vorrang",
conflict_assetwrx_wins_desc: "Ihr System lässt Datensätze, die in AssetWRX geändert wurden, unverändert.",
previewTitle: "Vor dem Test prüfen",
previewHint: "Bestätigen Sie den Geschäftszweck, den Zugriff und die Verarbeitungsregeln. Der Test aktiviert die Verbindung nicht.",
previewConnection: "Verbindung",
previewAccess: "Zugriff",
previewDestination: "Ziel",
previewEvents: "Ereignisse",
previewScopeCount_one: "{{count}} Berechtigung nach dem Minimalprinzip",
previewScopeCount_other: "{{count}} Berechtigungen nach dem Minimalprinzip",
previewConflict: "Konfliktrichtlinie",
previewProviderDefault: "Anbietersicherer Standard",
previewRetry: "Wiederholungen",
previewIdempotent: "Idempotent; doppelte Ereignisse werden ignoriert",
secretOnce: "Kopieren Sie dies jetzt — aus Sicherheitsgründen wird es nicht erneut angezeigt.",
secretSaved: "Ich habe dies sicher gespeichert",
copy: "Kopieren",
copied: "Kopiert",
testConnection: "Verbindung testen",
testStatusExplain: "Wir rufen den schreibgeschützten Status-Endpunkt mit Ihrem neuen Schlüssel auf, um die Funktion zu bestätigen. Dabei wird nichts erstellt oder geändert.",
connected: "Verbunden",
connectedDetail: "AssetWRX hat die Zugangsdaten akzeptiert und erfolgreich geantwortet.",
connectionFailed: "Verbindung fehlgeschlagen",
quickStartExplain: "Richten Sie Ihre App auf diese Basis-URL aus und senden Sie Ihren Schlüssel im Header x-asset-inspector-key.",
baseUrlLabel: "Basis-URL",
firstRequestLabel: "Erste Anfrage",
quickStartKeyNote: "Ersetzen Sie YOUR_API_KEY durch den soeben gespeicherten Schlüssel. Wir speichern ihn niemals in Beispielen.",
ready: "Ihre Verbindung ist bereit",
readyDetail: "Sie können sie jederzeit unter „Ihre Verbindungen“ verwalten.",
activating: "Wird eingeschaltet…",
activateFailed: "Ihre Verbindung ist noch nicht aktiv",
activateFailedDetail: "Wählen Sie Erneut versuchen. Es wurde noch nichts eingeschaltet.",
done: "Fertig",
na_openGuides: "Entwicklerleitfäden öffnen",
na_openReference: "API-Referenz öffnen",
na_setupEvents: "Ereignisse einrichten",
na_createAutomation: "Automatisierung erstellen",
na_manageSource: "Quelle & Regeln verwalten",
identifierExplain: "Jedes eingehende Ereignis muss angeben, zu welcher Anlage es gehört. Wählen Sie, wie Ihre Geräte Anlagen identifizieren.",
idKind_external: "Externe ID",
idKind_qr: "QR-Code",
createSource: "Datenquelle erstellen",
sourceCreated: "Datenquelle erstellt",
sourceFailed: "Datenquelle konnte nicht erstellt werden",
ingestTokenLabel: "Ingest-Token",
ingestAddressLabel: "Adresse, an die die Geräte senden",
ingestHowTo: "Geben Sie dem Geräteteam diese Adresse und das Ingest-Token. Jede Nachricht ist ein HTTPS-POST an die Adresse mit dem Token im Header x-connected-source-token.",
sendAnotherTest: "Andere Kennung testen",
sendTestExplain: "Senden Sie jetzt ein sicheres Testereignis. Geben Sie optional eine echte Anlagenkennung ein, um eine Live-Zuordnung zu sehen.",
testIdentifierLabel: "Anlagenkennung (optional)",
sendTestEvent: "Testereignis senden",
eventMatched: "Ereignis empfangen · Anlage zugeordnet",
eventMatchedDetail: "AssetWRX hat das Ereignis akzeptiert und mit der passenden Anlage verknüpft.",
eventUnmatched: "Ereignis empfangen · Anlage nicht identifiziert",
eventUnmatchedDetail: "Die Pipeline funktioniert — wir konnten diese Kennung nur keiner Anlage zuordnen. Geben Sie eine echte Anlagenkennung ein oder lösen Sie dies später unter „Connected-Ereignisse“.",
eventFailed: "Das Ereignis wurde abgelehnt",
title_business: "Ein Geschäftssystem verbinden",
business_choose_title: "Was verbinden Sie?",
business_choose_hint: "Geben Sie einen Namen ein, den Sie wiedererkennen, und wählen Sie die Art des Systems.",
business_outcome_title: "Was soll es tun?",
business_outcome_hint: "Dies hilft uns, den richtigen sicheren Zugriff zu empfehlen.",
business_mapping_title: "Datensätze und Konflikte zuordnen",
business_mapping_hint: "Verwenden Sie stabile externe Kennungen und legen Sie fest, was passiert, wenn beide Systeme einen Datensatz geändert haben.",
business_access_title: "Sicheren Zugriff erstellen",
business_access_hint: "AssetWRX erstellt für diese Verbindung ein Dienstkonto und einen einzelnen API-Schlüssel.",
business_test_title: "Verbindung testen",
business_activate_title: "Fertig",
sys_erp: "ERP",
sys_crm: "CRM",
sys_finance: "Finanzen",
sys_maintenance: "Wartung",
sys_data: "Datenplattform",
sys_custom: "Individuelle Anwendung",
sys_other: "Sonstiges",
title_developer: "Eine individuelle Anwendung erstellen",
dev_choose_title: "Benennen Sie Ihre Anwendung",
dev_choose_hint: "Dies kennzeichnet den API-Schlüssel, damit Sie ihn später wiederfinden.",
dev_access_title: "Sicheren Zugriff erstellen",
dev_access_hint: "Wählen Sie den geringsten Zugriff, den diese Anwendung braucht. Uneingeschränkter Zugriff ist in der erweiterten Konsole.",
dev_quickstart_title: "Stellen Sie Ihre erste Anfrage",
dev_activate_title: "Fertig",
title_iot: "Eine Datenquelle verbinden",
iot_choose_title: "Benennen Sie die Quelle",
iot_choose_hint: "Was sendet Daten an AssetWRX?",
iot_configure_title: "Wie werden Anlagen identifiziert?",
iot_token_title: "Quelle absichern",
iot_token_hint: "Geräte senden dieses Token im Header x-connected-source-token.",
iot_test_title: "Erstes Ereignis senden",
iot_activate_title: "Fertig",
src_device: "Gerät / Sensor",
src_gateway: "IoT-Gateway",
src_platform: "IoT-Plattform",
src_external: "Externes System",
title_webhook: "Eine Ereignisverbindung erstellen",
wh_choose_title: "Benennen Sie diese Ereignisverbindung",
wh_choose_hint: "Wenn in AssetWRX etwas passiert, wohin sollen wir es senden?",
wh_configure_title: "Ziel und Ereignisse",
wh_secret_title: "Signaturschlüssel generieren",
wh_test_title: "Testereignis senden",
wh_activate_title: "Aktivieren",
destUrlLabel: "Ziel-URL",
destUrlError: "Geben Sie eine gültige https://-URL ein.",
chooseEvents: "Welche Änderungen sollen wir senden?",
signingExplain: "Überprüfen Sie diese Signatur bei jeder Zustellung, um zu bestätigen, dass sie wirklich von AssetWRX stammt.",
signingSecretLabel: "Signaturschlüssel",
generateSecret: "Signaturschlüssel generieren",
webhookCreated: "Ereignisverbindung erstellt",
webhookFailed: "Ereignisverbindung konnte nicht erstellt werden",
webhookTestExplain: "Senden Sie jetzt eine signierte Testzustellung an Ihren Endpunkt, um zu bestätigen, dass er Ereignisse empfangen kann.",
sendTestDelivery: "Testzustellung senden",
webhookTestSent: "Testereignis zugestellt",
webhookTestDetail: "Ihr Endpunkt hat eine signierte {{event}}-Zustellung{{http}} akzeptiert.",
webhookTestRejected: "Ihr Endpunkt hat das Testereignis nicht akzeptiert",
webhookTestFailed: "Testereignis konnte nicht gesendet werden",
na_viewDeliveries: "Zustellungen anzeigen",
evtgrp_assets: "Anlagen",
evt_asset_created: "Anlage erstellt",
evt_asset_updated: "Anlage aktualisiert",
evt_asset_deleted: "Anlage gelöscht",
evtgrp_inspections: "Prüfungen",
evt_inspection_created: "Prüfung erstellt",
evt_inspection_updated: "Prüfung aktualisiert",
evt_inspection_completed: "Prüfung abgeschlossen",
evtgrp_wrx: "WRX (Aufträge)",
evt_job_created: "WRX erstellt",
evt_job_status: "WRX-Status geändert",
evt_job_completed: "WRX abgeschlossen",
evtgrp_contacts: "Kontakte",
evt_contact_created: "Kontakt erstellt",
evt_contact_updated: "Kontakt aktualisiert",
evtgrp_connected: "Connected-Daten",
evt_connected_received: "Connected-Ereignis empfangen",
evt_connected_unresolved: "Connected-Ereignis nicht zugeordnet",
evt_connected_alert: "Connected-Warnung ausgelöst",
title_automation: "Einen Prozess automatisieren",
auto_choose_title: "Was möchten Sie automatisieren?",
auto_choose_hint: "Wählen Sie einen Ausgangspunkt. Sie können anschließend alles feinabstimmen.",
auto_configure_title: "Automatisierung erstellen",
auto_configure_hint: "Ein paar Auswahlen, dann lesen Sie den Satz — genau das wird passieren.",
auto_test_title: "Automatisierung testen",
auto_activate_title: "Fertig",
tmpl_inspection_issue: "Wenn eine Prüfung abgeschlossen wird",
tmpl_wrx_completed: "Wenn ein WRX abgeschlossen wird",
tmpl_wrx_status: "Wenn sich ein WRX-Status ändert",
tmpl_asset_changed: "Wenn sich eine Anlage ändert",
tmpl_scratch: "Von Grund auf neu beginnen",
tmpl_inbound_webhook: "Wenn ein anderes System Ihren Webhook aufruft",
tmpl_action_create_wrx: "Einen Arbeitsauftrag (WRX) erstellen",
tmpl_action_send_event: "An Ihren Webhook senden",
tmpl_action_notify: "Ein anderes System benachrichtigen",
tmpl_action_choose: "Sie wählen im Builder",
tmpl_action_inbound_wrx: "Einen WRX aus der Anfrage erstellen",
automationCreateExplain: "Wir erstellen diese Automatisierung als Entwurf. Sie fügen die genauen Bedingungen und Aktionen im Builder hinzu und aktivieren sie anschließend.",
createAutomation: "Automatisierung erstellen",
automationCreated: "Automatisierung als Entwurf erstellt",
automationFailed: "Automatisierung konnte nicht erstellt werden",
automationTestExplain: "Führen Sie die Automatisierung jetzt einmal aus, um zu bestätigen, dass der Trigger verknüpft ist. Automatisierungsentwürfe lösen nicht von selbst aus.",
runTest: "Test ausführen",
automationRan: "Testlauf abgeschlossen",
automationRanDetail: "Laufstatus: {{status}}. Fügen Sie im Builder Aktionen hinzu, damit sie etwas bewirkt.",
automationCreateExplain2: "Wir erstellen diese Automatisierung mit Trigger und einer ersten Aktion, bereit zum Testen und Aktivieren.",
automationCreatedWithAction: "Automatisierung erstellt",
automationDraftDetail: "Fügen Sie im Builder die Aktionen hinzu, die ausgeführt werden sollen.",
automationInboundReady: "Ihre eingehende Webhook-URL und das Token werden unten angezeigt. Kopieren Sie das Token jetzt.",
automationDestUrlLabel: "Wohin sollen wir es senden?",
automationDestUrlHint: "Wir senden jedes passende Ereignis signiert per POST an diese HTTPS-URL, damit Sie es überprüfen können.",
automationInboundOnce: "Dies ist Ihr eingehender Webhook. Kopieren Sie das Token jetzt — es wird nicht erneut angezeigt.",
automationInboundUrlLabel: "Webhook-URL (hier POSTen)",
automationInboundTokenLabel: "Geheimes Token",
autoJobTitle: "Automatisierter Arbeitsauftrag",
automationRanDetail2: "Laufstatus: {{status}}. Dies hat die Aktion der Automatisierung einmal mit Beispieldaten ausgeführt.",
automationRunFailed: "Testlauf fehlgeschlagen",
na_openBuilder: "Automatisierungs-Builder öffnen",
title_ai: "Einen KI-Agenten verbinden",
ai_choose_title: "Benennen Sie die KI-Verbindung",
ai_choose_hint: "Zum Beispiel der Assistent oder Agent, den Sie verbinden möchten.",
ai_nameLabel: "Benennen Sie diese Verbindung",
ai_modeLabel: "Wie möchten Sie sich verbinden?",
ai_modeFirstParty: "Einem KI-Assistenten die Nutzung von AssetWRX erlauben",
ai_modeFirstPartyDesc: "Aktivieren Sie den AssetWRX-MCP-Server, damit genehmigte Assistenten sicher lesen und Aktionen vorschlagen können.",
ai_modeExternal: "Einen externen MCP-Server verbinden",
ai_modeExternalDesc: "Registrieren Sie einen MCP-Server eines Drittanbieters über dessen URL, damit AssetWRX seine Tools und Ressourcen aufrufen kann.",
mcpExternalExplain: "Geben Sie die HTTPS-URL des MCP-Servers ein und wie AssetWRX sich dort authentifizieren soll.",
mcpBaseUrlLabel: "Server-URL",
mcpAuthLabel: "Authentifizierung",
mcpAuthNone: "Keine Authentifizierung",
mcpAuthBearer: "Bearer-Token",
mcpAuthApiKey: "API-Schlüssel",
mcpAuthCustom: "Benutzerdefinierter Header",
mcpHeaderNameLabel: "Headername",
mcpSecretPlaceholder: "Secret / Token",
mcpRegister: "Server registrieren",
mcpRegistered: "Externer Server registriert",
mcpRegisterFailed: "Server konnte nicht registriert werden",
mcpNoKeyExplain: "Diese Verbindung verwendet die soeben eingegebenen Zugangsdaten für den externen Server. Ein AssetWRX-Schlüssel ist nicht erforderlich.",
mcpExternalTestExplain: "Wir verbinden uns mit dem Server und listen die bereitgestellten Tools und Ressourcen auf.",
mcpTestConnection: "Verbindung testen",
mcpTestFailed: "Server konnte nicht erreicht werden",
mcpConnected: "Mit dem Server verbunden",
mcpDiscovered: "{{tools}} Tools und {{resources}} Ressourcen gefunden.",
ai_enable_title: "KI-Zugriff erlauben",
ai_access_title: "Zugriffsebene wählen",
ai_access_hint: "Legen Sie fest, was die KI sehen und tun darf. Sie kann Änderungen nur vorschlagen, die weiterhin bestätigt werden müssen.",
ai_test_title: "Verbindung überprüfen",
ai_activate_title: "Fertig",
mcpExplain: "Genehmigte KI-Assistenten und -Agenten können ausgewählte AssetWRX-Informationen sicher lesen und Aktionen vorschlagen. Jede von einer KI vorgeschlagene Änderung muss weiterhin bestätigt werden.",
mcpEndpointLabel: "Endpunkt der KI-Verbindung",
enableAi: "KI-Zugriff aktivieren",
mcpEnabled: "KI-Zugriff aktiviert",
mcpEnableFailed: "KI-Zugriff konnte nicht aktiviert werden",
mcpVerifyExplain: "Wir bestätigen, dass der Schlüssel funktioniert und der KI-Connector erreichbar ist. Dabei wird nichts geändert.",
verifyAi: "KI-Verbindung überprüfen",
mcpActive: "KI-Verbindung ist aktiv",
mcpDegraded: "KI-Verbindung aktiviert",
mcpVerifyDetail: "Der Schlüssel funktioniert und der KI-Connector hat geantwortet. Genehmigte Agenten können sich jetzt verbinden.",
mcpVerifyFailed: "KI-Verbindung konnte nicht überprüft werden",
na_reviewActivity: "KI-Aktivität prüfen",
title_files: "Dateiaustausch einrichten",
files_choose_title: "Benennen Sie diese Dateiverbindung",
files_choose_hint: "Laden Sie Dokumente und Dateien mit kurzlebigen, sicheren Links zu AssetWRX hoch oder herunter.",
files_access_title: "Sicheren Zugriff erstellen",
files_access_hint: "„Anlagenbetrieb“ umfasst Hoch- und Herunterladen; „Nur Lesen“ umfasst nur das Herunterladen.",
files_test_title: "Dateiaustausch testen",
files_activate_title: "Fertig",
na_openFilesGuide: "Dateileitfaden öffnen",
filesReady: "Dateiaustausch ist bereit",
filesReadOnlyDetail: "Dieser Schlüssel kann Dateien herunterladen, aber nicht hochladen. Daher haben wir die Anmeldung geprüft. Download-Links funktionieren für Dateien, die bereits in AssetWRX sind.",
filesReadyReadOnly: "Dateiaustausch ist bereit (nur Download)",
filesBothDetail: "Signierte Upload- und Download-Links wurden erfolgreich ausgestellt.",
filesUploadDetail: "Ein signierter Upload-Link wurde ausgestellt. Downloads verwenden denselben sicheren Link-Mechanismus.",
filesTestFailed: "Signierte Links konnten nicht ausgestellt werden",
filesTestExplain: "Wir fordern mit Ihrem neuen Schlüssel einen kurzlebigen, signierten Upload-Link von AssetWRX an. Dabei wird nichts hochgeladen — dies belegt nur, dass die Verbindung Dateien übertragen kann.",
filesObjectKey: "Beispiel-Objektschlüssel",
filesTest: "Dateiaustausch testen",
automationScratchExplain: "Wir legen eine leere Automatisierung an, die Sie im erweiterten Editor aufbauen können.",
automationEventReady: "Bereit, eigenständig zu laufen",
automationEventTestExplain: "Diese läuft von selbst, wenn der Arbeitsbereich das tut, worauf sie wartet. Nichts zu drücken — jeder Lauf erscheint in ihrem Verlauf.",
},
home: {
eyebrow: "Workspace-Integrationen",
title: "Was möchten Sie erreichen?",
subtitle: "Wählen Sie das gewünschte Geschäftsergebnis. AssetWRX führt Sie durch die sichere Einrichtung, den Test und die Aktivierung.",
resumeTitle: "Einrichtung fortsetzen",
discardDraft: "Gespeicherte Einrichtung verwerfen",
card_business_title: "Ein weiteres Geschäftssystem verbinden",
card_business_desc: "Verbinden Sie ein ERP-, CRM-, Finanz- oder Wartungssystem oder eine andere Geschäftsanwendung.",
card_business_cta: "System verbinden",
card_webhook_title: "Reagieren, wenn etwas passiert",
card_webhook_desc: "Senden Sie Ereignisse an ein anderes System, wenn sich eine Anlage, Inspektion, ein Auftrag oder eine Anfrage ändert.",
card_webhook_cta: "Ereignisverbindung erstellen",
card_automation_title: "Einen Prozess automatisieren",
card_automation_desc: "Führen Sie automatisch Aktionen aus, wenn in AssetWRX oder einem anderen verbundenen System etwas passiert.",
card_automation_cta: "Automatisierung erstellen",
card_iot_title: "Sensoren und Geräte verbinden",
card_iot_desc: "Übernehmen Sie Messwerte von Sensoren und Geräten in AssetWRX und verknüpfen Sie sie mit der richtigen Anlage.",
card_iot_cta: "Datenquelle verbinden",
card_ai_title: "Einen KI-Agenten verbinden",
card_ai_desc: "Erlauben Sie genehmigten KI-Assistenten und -Agenten, sicher mit AssetWRX zu arbeiten.",
card_ai_cta: "KI verbinden",
card_developer_title: "Eine individuelle Anwendung erstellen",
card_developer_desc: "Nutzen Sie die AssetWRX-API, um individuelle Anwendungen und Integrationen zu erstellen.",
card_developer_cta: "Entwicklung starten",
card_files_title: "Dateien austauschen",
card_files_desc: "Laden Sie Dokumente und Dateien mit kurzlebigen, sicheren Links zu AssetWRX hoch oder herunter.",
card_files_cta: "Dateiaustausch einrichten",
card_import_title: "Datensätze aus einer Tabelle importieren",
card_import_desc: "Übernehmen Sie Anlagen oder Kontakte aus einer CSV- oder Excel-Datei. Ordnen Sie Ihre Spalten den richtigen Feldern zu, prüfen Sie die Vorschau und erstellen Sie dann die Datensätze.",
card_import_cta: "Aus Datei importieren",
card_power_bi_title: "Berichte in Power BI",
card_power_bi_desc: "Laden Sie Anlagen, Inspektionen und Aufträge in Power BI oder Excel, aktualisiert nach Ihrem Zeitplan.",
card_power_bi_cta: "Power BI einrichten",
card_power_automate_title: "Power Automate nutzen",
card_power_automate_desc: "Starten Sie Microsoft-Flows, wenn sich Arbeit ändert, und legen Sie Aufträge und Inspektionen aus Ihren Flows an.",
card_power_automate_cta: "Power Automate einrichten",
tier_start_title: "Einfach starten",
tier_start_subtitle: "Schritt für Schritt geführt. Manche geben Ihnen einen Schlüssel für die Person, die das andere System betreut.",
tier_data_title: "Daten, Ereignisse und Automatisierung",
tier_data_subtitle: "Verschieben Sie Daten, reagieren Sie auf Änderungen und automatisieren Sie Arbeit.",
tier_dev_title: "Entwicklung und KI",
tier_dev_subtitle: "Bauen Sie auf der API auf und verbinden Sie KI-Agenten.",
connectionsTitle: "Ihre Verbindungen",
connectionsEmptyTitle: "Noch keine Verbindungen",
connectionsEmptyDesc: "Wählen Sie oben ein Ziel aus, um Ihr erstes System zu verbinden.",
connectionsEmptyMember: "Verbindungen richtet der Workspace-Inhaber ein.",
connectionsLoadFailed: "Ihre Verbindungen konnten nicht geladen werden.",
connectionsRetry: "Erneut versuchen",
lockedSubtitle: "Verbinden Sie andere Systeme, automatisieren Sie Arbeit und binden Sie Sensoren oder KI-Agenten an.",
activityNever: "Noch keine Aktivität",
status_draft: "Entwurf",
status_testing: "Wird getestet",
status_active: "Aktiv",
status_paused: "Pausiert",
status_error: "Aufmerksamkeit erforderlich",
status_archived: "Inaktiv",
devToolsTitle: "Entwicklertools",
dev_api_title: "API-Referenz",
dev_api_subtitle: "Durchsuchen Sie die Live-REST- & GraphQL-Referenz.",
dev_docs_title: "Leitfäden & Dokumentation",
dev_docs_subtitle: "Aufgabenbasierte Leitfäden, Beispiele und Problembehandlung.",
dev_advanced_title: "Erweiterte Konsole",
dev_advanced_subtitle: "Alle Schlüssel, KI-Zugriffe, Automatisierungen und eingehenden Daten an einem Ort.",
dev_keys_title: "API-Schlüssel",
dev_keys_subtitle: "Erstellen, rotieren und widerrufen Sie die Schlüssel Ihrer Integrationen.",
dev_ai_title: "Zugriff für KI-Assistenten",
dev_ai_subtitle: "Legen Sie fest, was externe KI-Assistenten sehen und tun dürfen, und genehmigen Sie ihre Änderungen.",
devTitle: "Verbinden, entwickeln und automatisieren",
devSectionTitle: "Entwicklung & Referenz",
devSectionSubtitle: "Für Teams, die Systeme direkt verbinden, KI-Assistenten Zugriff geben oder Schlüssel verwalten.",
devSectionSubtitleApi: "Für Teams, die Systeme direkt verbinden oder Schlüssel verwalten.",
devSectionSubtitleMcp: "Für Teams, die KI-Assistenten Zugriff geben, mit Schritt-für-Schritt-Leitfäden.",
devSectionSubtitleGuides: "Anleitungen, Beispiele und Fehlerbehebung für Ihre Integrationen.",
journeyUnavailableTitle: "Noch nicht verfügbar",
journeyUnavailableDesc: "Dieser Ablauf wird gerade eingerichtet. Schauen Sie bald wieder vorbei.",
},
connection: {
type_business_system: "Geschäftssystem",
type_event_webhook: "Webhook",
type_automation: "Automatisierung",
type_iot_connected: "Sensoren und IoT",
type_ai_mcp: "KI-Agent",
type_developer_app: "Eigene Anwendung",
type_file_exchange: "Dateiaustausch",
overview: "Übersicht",
lastActivity: "Letzte Aktivität",
source: "Quelle",
sourceManaged: "Verwaltete Verbindung",
sourceDerived: "Von einer vorhandenen Ressource abgeleitet",
whatsConnected: "Was verbunden ist",
noResources: "Keine verknüpften Ressourcen.",
activity: "Letzte Aktivität",
activityEmpty: "Noch keine aktuelle Aktivität vorhanden.",
health_healthy: "Fehlerfrei",
health_attention: "Aufmerksamkeit erforderlich",
health_inactive: "Inaktiv",
health_active: "Aktiv",
health_degraded: "Beeinträchtigt",
health_paused: "Pausiert",
health_revoked: "Entzogen",
healthTitle: "Verbindungsstatus",
lastSuccess: "Letzter Erfolg",
lastFailure: "Letzter Fehler",
noFailure: "Keine erfasst",
affectedObjects: "Betroffene Objekte",
recovery_manage: "Verbindung verwalten",
recovery_recover: "Fehler prüfen und erneut verbinden",
recovery_resume: "Verbindung fortsetzen",
recovery_review_history: "Zugriffsverlauf prüfen",
notFoundTitle: "Verbindung nicht gefunden",
notFoundDesc: "Sie wurde möglicherweise entfernt. Zurück zur Integrationsübersicht.",
actionFailed: "Verbindung konnte nicht aktualisiert werden.",
archiveTitle: "Verbindungszugriff entziehen?",
archiveMsg: "Der Zugriff wird sofort beendet. Konfiguration und Aktivitätsverlauf bleiben für Audits verfügbar.",
archive: "Zugriff entziehen",
pause: "Pausieren",
activate: "Aktivieren",
openAdvanced: "In erweiterter Konsole öffnen",
kind_service_account: "API-Schlüssel",
kind_webhook_subscription: "Ereignisverbindung (Webhook)",
kind_connected_source: "Connected-Datenquelle",
kind_mcp_server: "KI-/MCP-Server",
kind_automation_recipe: "Automatisierungsrezept",
},
docs: {
title: "Leitfäden & Dokumentation",
subtitle: "Aufgabenbasierte Leitfäden, funktionierende Beispiele und Problembehandlung.",
notFound: "Leitfaden nicht gefunden",
achieve: "Was Sie erreichen",
need: "Was Sie benötigen",
steps: "Schritte",
verify: "So erkennen Sie, dass es funktioniert hat",
failure: "Wenn es fehlschlägt",
next: "Nächste Schritte",
rawHandbook: "Handbuch im Rohformat (erweitert)",
minutes_one: "{{count}} Min.",
minutes_other: "{{count}} Min.",
minutesRead_one: "{{count}} Min. Lesezeit",
minutesRead_other: "{{count}} Min. Lesezeit",
section: {
gettingStarted: { title: "Erste Schritte", description: "Verbinden Sie Ihr erstes System und machen Sie Ihren ersten Aufruf." },
guides: { title: "Anleitungen", description: "Verbinden Sie gängige Systeme und Plattformen Schritt für Schritt." },
api: { title: "API", description: "REST, GraphQL, Authentifizierung, Fehler und Anfrage-IDs." },
events: { title: "Ereignisse", description: "Ausgehende Webhooks, Signaturen, Wiederholungen und Idempotenz." },
automation: { title: "Automatisierung", description: "Auslöser, Bedingungen und Aktionen." },
connected: { title: "Verbundene Daten", description: "Senden Sie Geräte- und Sensordaten und ordnen Sie sie Anlagen zu." },
aiMcp: { title: "KI & MCP", description: "Lassen Sie genehmigte KI-Agenten sicher mit AssetWRX arbeiten." },
security: { title: "Sicherheit", description: "Minimale Rechte, Schlüsselrotation und Prüfverlauf." },
troubleshooting: { title: "Problembehandlung", description: "Beheben Sie die häufigsten Integrationsprobleme nach Symptom." },
},
guide: {
integrationOverview: { title: "Integrationen im Überblick", summary: "Wie AssetWRX sich mit anderen Systemen verbindet." },
connectFirstSystem: { title: "Ihr erstes System verbinden", summary: "Legen Sie einen sicheren Zugang an und sehen Sie, dass er funktioniert." },
authentication: { title: "Authentifizierung", summary: "So authentifizieren Sie API-Anfragen." },
makeFirstRequest: { title: "Ihre erste API-Anfrage", summary: "Rufen Sie die API auf und lesen Sie eine erfolgreiche Antwort." },
connectErp: { title: "Ein ERP verbinden", summary: "Geben Sie Ihrem ERP (oder einem anderen Geschäftssystem) einen eigenen sicheren Zugang zu AssetWRX und übergeben Sie die ERP-Seite dann an die IT.", time: "20 Min., plus Zeit der IT" },
connectPowerAutomate: { title: "Power Automate verbinden", summary: "Legen Sie AssetWRX-Aufträge und -Inspektionen aus Ihren Microsoft-Flows an und starten Sie einen Flow, wenn sich in AssetWRX etwas ändert." },
connectPowerBi: { title: "Berichte in Power BI", summary: "Bringen Sie Ihre Anlagen, Inspektionen und Aufträge nach Power BI oder Excel, nach Zeitplan aktualisiert." },
embedInAPortal: { title: "AssetWRX in einem anderen Portal zeigen", summary: "Binden Sie AssetWRX-Bildschirme (Arbeit, eine Anlage, eine Inspektion, einen Auftrag) in Ihr Kundenportal oder Intranet ein.", time: "15 Min. für Sie, plus Ihr Webteam" },
embedInDynamics: { title: "AssetWRX in Dynamics 365 zeigen", summary: "Die AssetWRX-Anlage im Dynamics-365-Formular Customer Asset, mit Microsoft angemeldet, das Formular wird nach erledigter Arbeit aktualisiert.", time: "30 Min. für Sie, etwa eine Stunde für die IT" },
sendIotData: { title: "Sensor- und Gerätedaten senden", summary: "Lassen Sie Sensoren, Gateways oder ein anderes System Messwerte und Warnungen an AssetWRX senden, der richtigen Anlage zugeordnet.", time: "15 Min., plus Zeit des Geräteteams" },
receiveEvents: { title: "AssetWRX-Ereignisse empfangen", summary: "Lassen Sie AssetWRX eine Nachricht an ein anderes System senden, wenn sich eine Anlage, Inspektion, ein Auftrag oder eine Anfrage ändert.", time: "15 Min., plus Zeit der IT" },
connectAiAgent: { title: "Einen KI-Agenten verbinden", summary: "Lassen Sie einen genehmigten KI-Assistenten Ihre AssetWRX-Daten lesen und Änderungen anfragen, die eine Person genehmigt.", time: "15 Min., plus Einrichtung des KI-Tools" },
uploadDownloadFiles: { title: "Dateien hoch- und herunterladen", summary: "Lassen Sie ein anderes System Dateien an AssetWRX senden und wieder abrufen, mit kurzlebigen, sicheren Links.", time: "10 Min., plus Zeit der IT" },
restApi: { title: "REST-API", summary: "Ressourcen, Methoden und Formate." },
paginationErrors: { title: "Seitenweise Abfrage, Fehler & Anfrage-IDs", summary: "Lesen Sie Listen Seite für Seite und analysieren Sie Fehler." },
permissionsScopes: { title: "Berechtigungen & Bereiche", summary: "Was jeder Bereich erlaubt." },
webhooks: { title: "Ausgehende Webhooks", summary: "Wie ausgehende Zustellungen funktionieren." },
signatureVerification: { title: "Signaturprüfung", summary: "Bestätigen Sie, dass eine Zustellung wirklich von AssetWRX stammt." },
automationGettingStarted: { title: "Automatisierung: erste Schritte", summary: "Auslöser, Bedingungen und Aktionen." },
assetMatching: { title: "Anlagenzuordnung", summary: "Wie Ereignisse Anlagen zugeordnet werden." },
unresolvedEvents: { title: "Nicht zugeordnete Ereignisse", summary: "Beheben Sie Ereignisse, die keiner Anlage zugeordnet wurden." },
mcpOverview: { title: "KI & MCP im Überblick", summary: "Wie KI-Verbindungen funktionieren." },
mcpSecurity: { title: "KI-Sicherheit & Genehmigungsmodell", summary: "Halten Sie den KI-Zugriff sicher." },
leastPrivilege: { title: "Minimale Rechte", summary: "Erteilen Sie nur, was eine Verbindung braucht." },
keyRotation: { title: "Schlüssel rotieren & widerrufen", summary: "Ersetzen oder deaktivieren Sie Schlüssel sicher." },
auditHistory: { title: "Prüfverlauf", summary: "Sehen Sie, wer was getan hat." },
apiRejected: { title: "Mein API-Aufruf wird abgelehnt", summary: "401 / 403 und Validierungsfehler." },
webhookNotArriving: { title: "Mein Webhook kommt nicht an", summary: "Zustellungen erreichen Ihren Endpunkt nie." },
eventNoAsset: { title: "Mein Ereignis findet keine Anlage", summary: "Verbundene Ereignisse bleiben nicht zugeordnet." },
automationDidNotRun: { title: "Meine Automatisierung lief nicht", summary: "Ein Rezept wurde nicht ausgelöst." },
aiCannotConnect: { title: "Mein KI-Agent verbindet sich nicht", summary: "Die KI-Verbindung schlägt fehl." },
},
},
access: {
title: "Sicherer Zugriff",
notFound: "Das Dienstkonto für diese Verbindung ist nicht verfügbar.",
keyCount: "{{active}} aktive(r) Schlüssel",
statusActive: "Aktiv",
statusRevoked: "Entzogen",
permissions: "Berechtigungen",
keys: "API-Schlüssel",
keyLine: "{{scopeCount}} Berechtigungen · erstellt am {{created}}",
expires: "läuft ab",
rotate: "Schlüssel rotieren",
rotateFailed: "Schlüssel konnte nicht rotiert werden.",
revokeFailed: "Widerruf nicht möglich. Der Schlüssel funktioniert weiterhin.",
revoke: "Entziehen",
rotateTitle: "Diesen Schlüssel erneuern?",
rotateMsg: "Der aktuelle Schlüssel funktioniert ab sofort nicht mehr. Hinterlegen Sie den neuen Schlüssel sofort in Power BI, Power Automate oder Ihrem System.",
revokeKeyTitle: "Diesen Schlüssel entziehen?",
revokeKeyMsg: "Aufrufe damit funktionieren sofort nicht mehr.",
revokeAll: "Zugriff entziehen",
revokeAllTitle: "Gesamten Zugriff entziehen?",
revokeAllMsg: "Das Dienstkonto und alle Schlüssel werden sofort entzogen. Dies kann nicht rückgängig gemacht werden.",
done: "Ich habe dies gespeichert",
},
connected: {
title: "Connected Ingestion",
notFound: "Die Datenquelle für diese Verbindung ist nicht verfügbar.",
statusActive: "Aktiv",
statusPaused: "Pausiert",
statusDisabled: "Deaktiviert",
tokenEnding: "Token endet auf {{last}}",
rotateToken: "Ingest-Token rotieren",
rotateFailed: "Token konnte nicht rotiert werden.",
pause: "Pausieren",
resume: "Fortsetzen",
resolveFailed: "Ereignis konnte nicht zugeordnet werden.",
unresolvedTitle: "Erfordert Aufmerksamkeit",
unresolvedEmpty: "Keine ungelösten Ereignisse.",
reasonAmbiguous: "Mehr als einer Anlage zugeordnet",
reasonNoMatch: "Keine passende Anlage",
resolveWith: "Zuordnen zu",
resolveInAdvanced: "In erweiterter Konsole zuordnen",
rulesTitle: "Regeln",
rulesEmpty: "Noch keine Regeln.",
manageRules: "Regeln verwalten",
cancel: "Abbrechen",
newRule: "+ Neue Regel",
ruleNameLabel: "Regelname (optional)",
ruleNamePlaceholder: "z. B. Warnung bei hoher Temperatur",
matchLabel: "Welche Ereignisse?",
matchAll: "Alle Ereignisse",
matchPrefix: "Beginnt mit",
actionLabel: "Dann",
actionAlert: "Eine Warnung auslösen",
actionReposition: "Standort aktualisieren",
actionPublish: "Ein Ereignis veröffentlichen",
actionJob: "Einen WRX erstellen",
actionValueLabel: "Aktionsdetail",
valueAlertPlaceholder: "Warnungstitel (optional)",
valueJobPlaceholder: "WRX-Titel (optional)",
createRule: "Regel erstellen (pausiert)",
ruleCreateFailed: "Regel konnte nicht erstellt werden.",
ruleUpdateFailed: "Regel konnte nicht aktualisiert werden.",
ruleActivate: "Aktivieren",
rulePause: "Pausieren",
ruleAdvancedNote: "Benötigen Sie Bedingungen oder eine Prüfvorlage? Öffnen Sie die erweiterte Konsole.",
eventsTitle: "Letzte Ereignisse",
eventsEmpty: "Noch keine Ereignisse empfangen.",
reprocess: "Erneut verarbeiten",
reprocessFailed: "Ereignis konnte nicht erneut verarbeitet werden.",
},
automation: {
title: "Automatisierung",
notFound: "Die Automatisierung für diese Verbindung ist nicht verfügbar.",
status_active: "Aktiv",
status_paused: "Pausiert",
status_draft: "Entwurf",
status_archived: "Archiviert",
trigger: "Auslöser",
steps_one: "{{count}} Aktion",
steps_other: "{{count}} Aktionen",
runResult: "Testlauf: {{status}}",
runFailed: "Automatisierung konnte nicht ausgeführt werden.",
activate: "Aktivieren",
pause: "Pausieren",
runNow: "Jetzt ausführen",
editInBuilder: "Im Builder bearbeiten",
actionFailed: "Aktion fehlgeschlagen.",
historyTitle: "Laufverlauf",
historyEmpty: "Noch keine Läufe.",
retry: "Wiederholen",
inboundTitle: "Eingehender Webhook",
inboundUrl: "Webhook-URL (hier POSTen)",
inboundNone: "Generieren Sie ein Secret, um die eingehende URL zu aktivieren.",
inboundToken: "Geheimes Token (wird einmal angezeigt)",
rotateSecret: "Secret rotieren",
lastRun: "Letzter Lauf",
never: "Nie",
nextRun: "Nächster Lauf",
testRun: "Testlauf",
turnOn: "Einschalten",
edit: "Bearbeiten",
hideSkipped: "Übersprungene ausblenden",
showSkipped_one: "{{count}} übersprungen",
showSkipped_other: "{{count}} übersprungen",
historyEmptyEvent: "Noch nichts passiert — sie läuft von selbst, wenn der Arbeitsbereich aktiv wird.",
historyOnlySkipped: "Alle bisherigen Läufe wurden übersprungen.",
fix: "Diese Automatisierung reparieren",
},
mcp: {
title: "KI-Verbindung (MCP)",
notFound: "Der MCP-Server für diese Verbindung ist nicht verfügbar.",
statusActive: "Aktiv",
statusDisabled: "Deaktiviert",
statusError: "Fehler",
toolsResources: "{{tools}} Tools · {{resources}} Ressourcen",
test: "Verbindung testen",
testOk: "Verbunden · {{protocol}}",
testFail: "Verbindung fehlgeschlagen",
discover: "Metadaten ermitteln",
discovered: "{{tools}} Tools · {{resources}} Ressourcen",
discoverFailed: "Metadaten konnten nicht ermittelt werden.",
enable: "Aktivieren",
disable: "Deaktivieren",
invocationsTitle: "Letzte Aktivität",
invocationsEmpty: "Noch keine Aktivität.",
manageAdvanced: "In erweiterter Konsole verwalten",
actionFailed: "Aktion fehlgeschlagen.",
credentials: "Zugangsdaten",
credentialsTitle: "Zugangsdaten aktualisieren",
credentialsSaved: "Zugangsdaten aktualisiert",
credentialsFailed: "Zugangsdaten konnten nicht aktualisiert werden.",
auth_none: "Keine Authentifizierung",
auth_bearer: "Bearer",
auth_api_key: "API-Schlüssel",
auth_custom_header: "Benutzerdefinierter Header",
headerName: "Headername",
secretPlaceholder: "Secret / Token",
saveCredentials: "Zugangsdaten speichern",
},
files: {
  title: "Ausgetauschte Dateien",
  empty: "Noch keine Dateien. Dateien, die Ihre Systeme über eine Dateiverbindung in diesen Workspace hochladen, erscheinen hier.",
  loadFailed: "Die Dateien konnten nicht geladen werden.",
  download: "Herunterladen",
  downloadFailed: "Die Datei konnte nicht heruntergeladen werden.",
},
webhook: {
  title: "Ereignisse",
  unavailable: "Das Ereignisabonnement dieser Verbindung konnte nicht geladen werden.",
  address: "Sendet an",
  secretEnding: "Signaturgeheimnis endet auf {{last}}",
  secretLabel: "Signaturgeheimnis",
  replace: "Signaturgeheimnis ersetzen",
  replaceTitle: "Signaturgeheimnis ersetzen?",
  replaceMsg: "Ereignisse werden sofort mit dem neuen Geheimnis signiert, daher lehnt das empfangende System sie ab, bis es das neue hat. Geben Sie es sofort weiter.",
  replaceFailed: "Das Signaturgeheimnis konnte nicht ersetzt werden.",
},
embeddedApps: {
  refusal_other: "beim Starten der Sitzung ist etwas schiefgelaufen. Versuchen Sie es erneut; wenn es wieder passiert, kontaktieren Sie den AssetWRX-Support.",
  refusal_assertion: "der Identitätsnachweis des Portals wurde nicht akzeptiert. Bitten Sie Ihre IT, die Anmeldeeinstellungen zu prüfen.",
  refusal_scope_denied: "das Portal hat etwas verlangt, das diese App nicht darf.",
  refusal_jit_refused: "die Person konnte nicht automatisch hinzugefügt werden.",
  refusal_unknown_user: "die Person ist mit niemandem in diesem Arbeitsbereich verknüpft.",
  refusal_jit_domain_refused: "die E-Mail-Domain der Person steht nicht auf der erlaubten Liste.",
  refusal_identity_unlinked: "ein Admin hat die Verknüpfung dieser Person aufgehoben. Verknüpfen Sie sie unten erneut.",
  refusal_identity_collision: "diese Anmeldung gehört hier bereits jemand anderem.",
  refusal_user_disabled: "das AssetWRX-Konto der Person ist deaktiviert.",
  refusal_wrong_tenant: "die Person hat ein Microsoft-Konto einer anderen Firma verwendet.",
  refusal_sso_required: "die Person hat sich nicht mit Microsoft angemeldet.",
  refusal_not_entitled: "der Tarif des Arbeitsbereichs enthält keine Einbettung.",
  refusal_view_not_permitted: "die Ansicht braucht eine Berechtigung, die diese App nicht hat.",
  refusal_not_a_member: "die Person ist kein Mitglied dieses Arbeitsbereichs.",
  refusal_bootstrap_expired: "die Person hat länger als eine Minute für die Anmeldung gebraucht. Ein Neuladen der Portalseite behebt das.",
  lastRefusalReason: "Letzte Ablehnung: {{reason}}",
  viewNeedsScope: "Diese Ansichten lassen sich erst öffnen, wenn Sie ihre Berechtigung unter „Was es tun darf“ wählen: {{views}}.",
  viewsHelp: "Wenn Sie eine Ansicht wählen, wird auch die nötige Berechtigung unter „Was es tun darf“ gewählt.",
  disableMsg: "Alle Portale, die sie nutzen, zeigen AssetWRX ab sofort nicht mehr, und offene Sitzungen enden. Sie können sie jederzeit wieder einschalten.",
  disableTitle: "{{name}} ausschalten?",
  removeOriginConfirm: "Website entfernen",
  removeOriginMsg: "Diese Website zeigt AssetWRX ab sofort nicht mehr. Wer sie nutzt, sieht dort eine leere Fläche, bis Sie sie wieder hinzufügen.",
  removeOriginTitle: "{{origin}} entfernen?",
  removeOriginShort: "Entfernen",
  outcomeCta: "Eingebettete App einrichten",
  outcomeTitle: "AssetWRX in einem anderen Portal anzeigen",
  ownerOnlyBodyUnnamed: "Bitten Sie den Inhaber Ihres Arbeitsbereichs, eine hinzuzufügen. Die Anleitungen oben zeigen, was dafür nötig ist.",
  ownerOnlyBody: "Bitten Sie {{owner}}, eine hinzuzufügen. Die Anleitungen oben zeigen, was dafür nötig ist.",
  ownerOnlyTitle: "Nur der Inhaber des Arbeitsbereichs kann eingebettete Apps einrichten",
title: "Eingebettete Apps",
subtitle: "Zeigen Sie AssetWRX in einem anderen Portal an, etwa Dynamics 365 oder einem Kundenportal. Legen Sie fest, welche Websites es einbinden dürfen, welche Ansichten sie öffnen und was diese Ansichten tun dürfen.",
cardSubtitle: "AssetWRX-Ansichten in einem anderen Portal anzeigen.",
guidePortal: "So richten Sie es ein",
guideDynamics: "Dynamics 365 einrichten",
create: "Neue eingebettete App",
defaultName: "Eingebettete App",
loadFailed: "Ihre eingebetteten Apps konnten nicht geladen werden. Sie wurden nicht verändert.",
emptyTitle: "Noch keine eingebetteten Apps",
emptyDesc: "Erstellen Sie eine, um festzulegen, welches Portal AssetWRX einbinden darf und was es zeigen darf.",
adminOnly: "Nur Inhaber und Administratoren des Arbeitsbereichs können eingebettete Apps verwalten.",
name: "Name",
save: "Speichern",
statusActive: "An",
statusDisabled: "Aus",
enable: "Einschalten",
disable: "Ausschalten",
publicId: "Öffentliche ID",
publicIdHelp: "Das Host-Portal übergibt diese ID. Sie ist nicht geheim und gewährt allein nichts.",
secretTitle: "Host-Geheimnis",
secretHelp: "Der Server Ihres Portals startet damit eingebettete Sitzungen. Bewahren Sie es auf dem Server auf, niemals in einer Webseite.",
secretNone: "Noch kein Geheimnis. Das Portal kann AssetWRX erst öffnen, wenn Sie eines erstellen.",
secretSet: "Geheimnis {{prefix}}… erstellt am {{date}}",
secretCreate: "Geheimnis erstellen",
secretRotate: "Geheimnis ersetzen",
secretRotateTitle: "Host-Geheimnis ersetzen?",
secretRotateMsg: "Das aktuelle Geheimnis funktioniert sofort nicht mehr. Hinterlegen Sie das neue auf dem Server Ihres Portals.",
secretShownOnce: "Kopieren Sie es jetzt. Es wird nicht erneut angezeigt.",
origins: "Zulässige Websites",
originsHelp: "Nur exakte Adressen, z. B. https://contoso.crm.dynamics.com. Platzhalter sind nicht erlaubt.",
originPlaceholder: "https://example.com",
addOrigin: "Website hinzufügen",
removeOrigin: "{{origin}} entfernen",
noOrigins: "Noch keine Websites. Nichts kann diese App einbinden, bis Sie eine hinzufügen.",
originErrorWildcard: "Platzhalter sind nicht erlaubt. Fügen Sie jede Website einzeln hinzu.",
originErrorInvalid: "Geben Sie eine Adresse wie https://portal.example.com ohne Pfad ein.",
views: "Ansichten, die es öffnen darf",
scopes: "Was es tun darf",
interactiveOff: "Zum Ändern von Daten sind interaktive Einbettungen in Ihrem Tarif nötig. Bis dahin gilt nur das Ansehen.",
userCeiling: "Niemand erhält mehr als seinen eigenen AssetWRX-Zugriff.",
identityTitle: "Anmeldung",
identityModeAssetwrx: "AssetWRX-Anmeldung",
identityModeSso: "Microsoft Entra SSO",
identityModeHost: "Vom Host bereitgestellt (Unternehmen)",
identityHelp_assetwrx: "Personen melden sich im Portal mit ihrem eigenen AssetWRX-Konto bei AssetWRX an.",
identityHelp_sso: "Personen melden sich mit dem Microsoft-Konto ihrer Organisation im unten angegebenen Mandanten an. Andere Konten und andere Mandanten werden abgelehnt.",
identityHelp_host: "Der Server des Portals bestätigt die Person mit einem ID-Token, das Ihr Identitätsanbieter signiert hat, daher ist keine zweite Anmeldung nötig. Die Person muss mit diesem Arbeitsbereich verknüpft sein oder wird automatisch hinzugefügt.",
idpEntra: "Microsoft Entra ID",
idpOidc: "Anderer OpenID Connect-Anbieter",
idpTenant: "Entra-Mandanten-ID",
idpTenantHelp: "Die Verzeichnis-ID (Mandanten-ID) der Organisation. Anmeldungen aus jedem anderen Mandanten werden abgelehnt.",
idpIssuer: "Aussteller",
idpIssuerHelp: "Die Webadresse, die Ihren Anmeldeanbieter benennt. Ihre IT kopiert sie aus den Einstellungen des Anbieters. Sie beginnt mit https://.",
idpAudience: "Zielgruppe",
idpAudienceHelp: "Die App-ID, die Ihr Portal beim Anmeldeanbieter verwendet. Ihre IT kopiert sie aus der App-Registrierung beim Anbieter.",
jitEnable: "Neue Personen automatisch hinzufügen",
jitHelp: "Aus: Nur bereits verknüpfte Personen oder bereits Mitglieder können die Portalansicht öffnen. Ein: Personen des Identitätsanbieters treten diesem Arbeitsbereich bei ihrem ersten Besuch bei. Eine E-Mail-Adresse mit bestehendem AssetWRX-Konto wird nie automatisch verknüpft.",
jitDomains: "Zulässige E-Mail-Domänen",
jitDomainsHelp: "Mit Kommas trennen. Leer lassen, um jede vom Identitätsanbieter angemeldete Person zuzulassen.",
jitTeam: "Team für neue Personen",
jitRole: "Neue Personen treten als Mitglieder bei, nie als Administratoren.",
sessionLifetime: "Sitzungsdauer",
hoursShort: "{{count}} Std.",
identitySave: "Anmeldeeinstellungen speichern",
identityStats: "Offene Sitzungen: {{sessions}} · Verknüpfte Personen: {{identities}} · Abgelehnt (30 Tage): {{denied}}",
lastDenied: "zuletzt abgelehnt am {{date}}",
linkedIdentities: "Verknüpfte Personen",
noLinkedIdentities: "Noch niemand verknüpft.",
linkedVia_admin: "Von einem Administrator verknüpft",
linkedVia_jit: "Automatisch hinzugefügt",
linkedVia_sso: "Microsoft-Anmeldung",
unlink: "Verknüpfung lösen",
unlinkTitle: "Verknüpfung dieser Person lösen?",
unlinkMsg: "Die eingebetteten Sitzungen der Person enden sofort, und der Identitätsanbieter kann sie hier erst wieder anmelden, wenn sie erneut verknüpft ist.",
linkSubject: "Benutzer-ID beim Identitätsanbieter",
linkSubjectHelp: "Die ID der Person bei Ihrem Anmeldeanbieter (in Microsoft Entra die Objekt-ID auf der Benutzerseite). Wählen Sie dann unten das Mitglied.",
link: "Verknüpfen",
theme: "Darstellung",
themeAssetwrx: "AssetWRX",
themeHost: "Wie Host",
themeLight: "Hell",
themeDark: "Dunkel",
viewWork: "Arbeit",
viewAssets: "Anlagen",
viewAsset: "Anlage",
viewInspection: "Inspektion",
viewJob: "Auftrag",
viewRequest: "Anfrage",
viewInspectionReport: "Inspektionsbericht",
viewJobReport: "Auftragsbericht",
created: "Erstellt am {{date}}",
lastUsed: "Zuletzt verwendet {{date}}",
neverUsed: "Nie verwendet",
delete: "Löschen",
deleteTitle: "{{name}} löschen?",
deleteMsg: "Portale, die sie verwenden, funktionieren sofort nicht mehr. Dies kann nicht rückgängig gemacht werden.",
cancel: "Abbrechen",
actionFailed: "Das wurde nicht gespeichert. Versuchen Sie es erneut.",
},
apiKeys: {
create: "API-Schlüssel erstellen",
defaultName: "API-Schlüssel",
createFailed: "Der Schlüssel konnte nicht erstellt werden. {{message}}",
address: "API-Adresse",
howPowerBi: "Wählen Sie in Power BI „Daten abrufen“ → „OData-Feed“, geben Sie {{url}}/v1/odata ein, dann „Standard“: ein beliebiger Benutzername und dieser Schlüssel als Kennwort.",
howHeader: "Senden Sie den Schlüssel bei jeder Anfrage im Header x-asset-inspector-key.",
openGuide: "Einrichtungsanleitung öffnen",
done: "Fertig",
nameLabel: "Name",
createButton: "Schlüssel erstellen",
manage: "Rotieren oder widerrufen",
hide: "Ausblenden",
},
serviceAccounts: {
title: "API-Schlüssel",
subtitle: "Erstellen Sie einen Schlüssel für Power BI, Power Automate oder Ihr eigenes System und rotieren oder widerrufen Sie ihn hier. Ein Schlüssel wird nur einmal angezeigt.",
emptyTitle: "Noch keine API-Schlüssel",
emptyDesc: "Erstellen Sie einen Schlüssel mit „API-Schlüssel erstellen“ oder in einem Verbindungsablauf.",
revokeTitle: "Diesen Zugriff entziehen?",
revokeMsg: "Das Dienstkonto und alle Schlüssel werden sofort entzogen. Dies kann nicht rückgängig gemacht werden.",
lastUsed: "Zuletzt verwendet am {{date}}",
neverUsed: "Nie verwendet",
created: "erstellt am {{date}}",
},
aiSettings: {
title: "AssetWRX KI (MCP)",
subtitle: "Legen Sie fest, was genehmigte KI-Assistenten mit AssetWRX tun dürfen. Jede von einer KI vorgeschlagene Änderung muss weiterhin bestätigt werden.",
exposure: "KI-Zugriff",
statusEnabled: "Aktiviert",
statusDisabled: "Deaktiviert",
enable: "KI-Zugriff aktivieren",
disable: "Deaktivieren",
endpointLabel: "MCP-Endpunkt",
approvalsLoadFailed: "Die KI-Anfragen, die auf Genehmigung warten, konnten nicht geladen werden.",
ttlLabel: "Ablauf des Vorschlags",
ttlHours_one: "{{count}} Stunde",
ttlHours_other: "{{count}} Stunden",
ttlHour: "1 Stunde",
toolsTitle: "Werkzeuge",
toolsEmpty: "Keine Tools verfügbar.",
writeAction: "Kann Änderungen vornehmen (Bestätigung erforderlich)",
rowEnable: "Aktivieren",
rowDisable: "Deaktivieren",
resourcesTitle: "Ressourcen",
resourcesEmpty: "Keine Ressourcen verfügbar.",
activityTitle: "Letzte KI-Aktivität",
activityEmpty: "Noch keine KI-Aktivität.",
actionFailed: "Aktualisierung fehlgeschlagen. Versuchen Sie es erneut.",
},
connectedPanel: {
eyebrow: "Verbundene Anlagen",
title: "Connected Event Ingestion",
subtitle: "Verwalten Sie Quellen, prüfen Sie eingehenden Datenverkehr, lösen Sie mehrdeutige Zuordnungen und fügen Sie Regeln hinzu. Verwenden Sie zuerst den Konfigurationsassistenten und dann die Abschnitte unten.",
},
connectedConfigWizard: {
eyebrow: "Konfiguration",
title: "Connected Ingestion einrichten",
lead: "Dieser Assistent führt Sie durch das Erstellen einer Quelle, das Absichern ihres Tokens, das Kopieren der Ingest-URL und das Verständnis optionaler Regeln.",
pillWelcome: "Starten",
pillSource: "Quelle",
pillEndpoint: "Ingest-URL",
pillRule: "Regeln",
pillComplete: "Fertig",
welcomeTitle: "Was Sie konfigurieren",
welcomeIntro: "Sie verknüpfen ein externes System (SCADA, Gateway, Skript), um JSON-Ereignisse per POST an diesen Workspace zu senden.",
welcomeStep1: "Erstellen Sie eine Connected-Quelle (logischer Posteingang).",
welcomeStep2: "Kopieren Sie das einmalige Ingest-Token aus dem sicheren Popup — derselbe Ablauf wie bei API-Schlüsseln.",
welcomeStep3: "Kopieren Sie die POST-URL und einen Beispiel-Payload für Ihre Integration.",
welcomeStep4: "Fügen Sie optional eine Regel hinzu: Wenn Ereignisse einem Muster entsprechen, wird eine klar definierte Aktion ausgeführt (Entwurf, Warnung oder Benachrichtigung).",
sourceTitle: "Eine Connected-Quelle erstellen",
sourceLead: "Geben Sie der Quelle einen verständlichen Namen, den Ihr Team wiedererkennt. Der interne Schlüssel muss eindeutig sein; lassen Sie ihn leer, um ihn automatisch zu generieren.",
fieldSourceName: "Anzeigename",
placeholderSourceName: "z. B. SPS Werk Nord",
fieldSourceKey: "Interner Schlüssel (optional)",
hintSourceKey: "Nur Buchstaben, Zahlen und Bindestriche. Wird in Protokollen und Metadaten verwendet — nicht für Absender sichtbar.",
placeholderSourceKey: "z. B. werk-nord-sps",
createSourceCta: "Quelle erstellen & Token anzeigen",
creating: "Wird erstellt…",
defaultSourceName: "Connected-Quelle {{n}}",
endpointTitle: "Ereignisse an diese URL senden",
endpointLead: "Ihr Absender muss HTTPS-POST mit JSON verwenden. Bevorzugen Sie das quellenspezifische Token im Header x-connected-source-token.",
postUrlLabel: "Ihre Ingest-URL",
copyPostUrl: "POST-Zeile kopieren",
copySampleJson: "Beispiel-JSON kopieren",
endpointNoSource: "Erstellen Sie im vorherigen Schritt eine Quelle (oder verwenden Sie oben „Neue Quelle“), um Ihre Ingest-URL hier zu sehen.",
endpointHeaderHint: "Erforderlicher Header bei Verwendung des Ingest-Tokens:",
endpointBearerHint: "Wenn Sie stattdessen ein Workspace-Dienstkonto verwenden, senden Sie Authorization: Bearer <API-Schlüssel> mit connected_*-Berechtigungen.",
openApiKeys: "API-Schlüssel & Zugriff öffnen",
ruleStepTitle: "Regeln (optional)",
ruleStepLead: "Regeln überwachen eingehende Ereignisse, nachdem sie gespeichert wurden. Wenn ein Ereignisschlüssel Ihrem Muster entspricht, führt AssetWRX eine Aktion aus — zum Beispiel eine Veröffentlichung in der Automatisierungs-Outbox, damit Rezepte reagieren können.",
ruleStepHint: "Verwenden Sie den Regel-Builder unten, um „wenn“ und „dann“ in einfacher Sprache festzulegen. Neue Regeln starten pausiert, damit Sie sie vor der Aktivierung prüfen können.",
completeTitle: "Sie sind bereit zur Integration",
completeBody: "Scrollen Sie nach unten, um Quellen zu verwalten, letzte Ereignisse zu prüfen, nicht zugeordnete Payloads zuzuordnen und Regeln anzupassen. Rotieren Sie das Ingest-Token jederzeit; jede Rotation zeigt das neue Secret einmalig im gleichen Popup an.",
},
connectedIngestModal: {
title: "Ingest-Token (wird einmal angezeigt)",
leadCreate: "Kopieren Sie dieses Token in einen Passwort-Manager oder Secret Store. Senden Sie es als Header x-connected-source-token bei jedem POST an diese Quelle.",
leadRotate: "Ihr vorheriges Ingest-Token hat mit der Rotation aufgehört zu funktionieren. Kopieren Sie das neue Token und aktualisieren Sie alle Absender, bevor der Datenverkehr fortgesetzt wird.",
copiedTitle: "Kopiert",
copiedBody: "Wert in die Zwischenablage kopiert.",
missingTokenTitle: "Kein Token zurückgegeben",
missingTokenBody: "Der Server hat kein neues Ingest-Token zurückgegeben. Versuchen Sie es erneut oder prüfen Sie die Edge-Function-Protokolle.",
},
connectedRules: {
builderTitle: "Eine Connected-Regel erstellen",
builderSubtitle: "Regeln beantworten: „Wenn ein Ereignis so aussieht, tue das.“ Muster verwenden Ereignisschlüssel (zum Beispiel telemetry.temperature oder connected.*). Aktionen werden erst ausgeführt, nachdem ein Ereignis gespeichert wurde; mehrere Aktionen erfordern, dass das Ereignis bereits einer Anlage zugeordnet ist.",
fieldRuleName: "Regelname (optional)",
placeholderRuleName: "z. B. Benachrichtigen bei eingehender Telemetrie",
whenLabel: "Wenn eingehende Ereignisse übereinstimmen mit",
whenHint: "Legen Sie fest, wie streng der Ereignisschlüssel abgeglichen wird. Die meisten Teams starten mit „Jedes Connected-Ereignis“ oder einem kurzen Präfix.",
matchAll: "Jedes Connected-Ereignis",
matchPrefix: "Präfix",
matchCustom: "Erweitertes Muster",
placeholderPrefix: "z. B. telemetry (wird zu telemetry.*)",
customHint: "Für erfahrene Nutzer: Geben Sie ein vollständiges Muster ein, z. B. connected.* oder job.status_changed.",
thenLabel: "Dann Folgendes tun",
actionTitle_outbox_publish: "In der Automatisierungs-Outbox veröffentlichen",
actionBody_outbox_publish: "Sendet ein Workspace-Ereignis, das andere Systeme und Automatisierungsrezepte verarbeiten können — ähnlich einer Webhook-Verteilung innerhalb von AssetWRX.",
actionTitle_asset_alert: "Eine Anlagenwarnung auslösen",
actionBody_asset_alert: "Schreibt einen sichtbaren Aktivitätseintrag auf der zugeordneten Anlage. Optionaler eigener Titel.",
actionTitle_asset_reposition: "Anlagenstandort aktualisieren",
actionBody_asset_reposition: "Wendet eine vom Gerät gemeldete Position an. Eine mobile Anlage bewegt sich unauffällig; alles, was stationär bleiben sollte, löst einen Hinweis für den Verantwortlichen aus.",
actionTitle_inspection_create: "Prüfungsentwurf erstellen",
actionBody_inspection_create: "Öffnet einen Prüfungsentwurf für die zugeordnete Anlage. Erfordert die UUID einer Checkliste.",
actionTitle_job_create: "Auftragsentwurf erstellen",
actionBody_job_create: "Öffnet einen Arbeitsentwurf, der mit der zugeordneten Anlage verknüpft ist, sofern der Resolver eine gefunden hat.",
fieldOutboxEventType: "Outbox-Ereignistyp",
fieldAlertTitle: "Warnungstitel (optional)",
placeholderAlertTitle: "Standardmäßig die Ereigniszusammenfassung, falls leer",
fieldChecklistTemplateId: "Checklisten-ID",
hintChecklistTemplateId: "UUID einer vorhandenen Checkliste in diesem Workspace. Der Prüfungsentwurf verwendet diese Checkliste.",
placeholderUuid: "00000000-0000-0000-0000-000000000000",
fieldJobTitle: "Auftragstitel (optional)",
placeholderJobTitle: "Standardmäßig ein aus dem Ereignis abgeleiteter Titel",
sourceScopeLabel: "Diese Regel anwenden auf",
sourceScopeHint: "Alle Quellen oder nur Ereignisse aus einer unten ausgewählten Quelle.",
sourceAll: "Alle Quellen",
createRuleCta: "Regel erstellen (startet pausiert)",
ruleCreated: "Regel erstellt",
defaultRuleName: "Regel für {{pattern}}",
ruleDescriptionAuto: "Erstellt über den Regel-Builder von Connected Ingestion.",
checklistRequiredTitle: "Checkliste erforderlich",
checklistRequiredBody: "Prüfungsentwürfe benötigen die UUID einer Checkliste. Fügen Sie eine aus Ihren Workspace-Checklisten ein oder wählen Sie eine andere Aktion.",
},
connectedSections: {
reload: "Neu laden",
newSource: "Neue Quelle",
rotateToken: "Token rotieren",
sourcesTitle: "Quellen",
sourcesSubtitle: "Jede Quelle hat ihre eigene Ingest-URL und ihren eigenen Token-Lebenszyklus.",
sourcesEmpty: "Noch keine Connected-Quellen.",
sourceActivity: "Zuletzt empfangen: {{received}} · Letztes Ereignis: {{last}}",
never: "Nie",
eventsTitle: "Letzte Ereignisse",
eventsSubtitle: "Die neuesten von der API akzeptierten Payloads (erneutes Verarbeiten ist unbedenklich, wenn der Support dies anweist).",
eventsEmpty: "Noch keine Connected-Ereignisse.",
noSummary: "Noch keine Assistenten-Zusammenfassung.",
assetLabel: "Anlage",
unresolved: "ungelöst",
reprocess: "Erneut verarbeiten",
reprocessed: "Ereignis erneut verarbeitet",
unresolvedTitle: "Warteschlange ungelöster Ereignisse",
unresolvedSubtitle: "Ereignisse, die nicht eindeutig einer Anlage zugeordnet werden konnten — manuell zuordnen und bei Bedarf erneut verarbeiten.",
unresolvedEmpty: "Keine ungelösten Connected-Ereignisse.",
resolveFirst: "Zuerst zuordnen",
candidates_one: "{{count}} mögliche Anlage",
candidates_other: "{{count}} mögliche Anlagen",
resolved: "Ereignis zugeordnet",
noCandidateTitle: "Kein Kandidat verfügbar",
noCandidateBody: "Für dieses ungelöste Ereignis ist keine gespeicherte Kandidatenanlage zur automatischen Anwendung vorhanden.",
rulesListTitle: "Gespeicherte Regeln",
rulesListSubtitle: "Aktivieren Sie eine Regel, sobald Sie mit Muster und Aktion zufrieden sind. Pausierte Regeln werden nie ausgeführt.",
rulesEmpty: "Noch keine Connected-Regeln.",
pause: "Pausieren",
activate: "Aktivieren",
noDescription: "Keine Beschreibung angegeben.",
ruleActivated: "Regel aktiv",
rulePaused: "Regel pausiert",
executionsTitle: "Ausführungsverlauf",
executionsSubtitle: "Die neuesten Ausführungen von Connected-Regeln mit Prüfstatus.",
executionsEmpty: "Noch keine Ausführungen von Connected-Regeln.",
attempt: "Versuch",
executionEvent: "Ereignis {{id}} · {{at}}",
alertActionTitle: "Connected-Verwaltungsaktion fehlgeschlagen",
alertActionBody: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
healthTitle: "Integrationszustand",
healthSubtitle: "Betriebsstatus, Wiederholungsstatus und neueste Aufnahmeergebnisse.",
healthLabel: "Zustand",
lastSuccessLbl: "Letzte erfolgreiche Synchronisierung",
lastFailedLbl: "Letzte fehlgeschlagene Synchronisierung",
logsLbl: "Protokolle/Verlauf",
logsVal: "{{e}} Ereignisse · {{r}} Läufe",
retryFailed: "Letztes fehlgeschlagenes Ereignis wiederholen",
copyPayload: "Test-Payload kopieren",
credsNote: "Anmeldeinformationen: Quell-Tokens werden einmal angezeigt, danach nur mit Präfix und den letzten vier Zeichen. Verwenden Sie Dienstkontoschlüssel mit connected_*-Bereichen für Bearer-Token-Integrationen.",
needsAction: "Aktion erforderlich",
needsReview: "Prüfung erforderlich",
healthyLbl: "Fehlerfrei",
notConfigured: "Nicht konfiguriert",
errPrefix: "Fehler: {{m}}",
seeSummary: "Siehe Zusammenfassung der Ausführungsausgabe.",
},
automationSubGuided: "Geführt",
automationSubRuns: "Verlauf",
automationSubExpert: "Experteneditor",
docsBarAutomationGuide: "Automatisierungsleitfaden",
docsBarIntegrationsOverview: "Übersicht zu Webhooks & Verbindungen",
docsBarBrowseApi: "Live-API-Referenz öffnen",
docsBarApiHandbook: "Vollständiger Verbindungsleitfaden",
docsBarOpenApiKeys: "API-Schlüssel & Dienstkonten",
docsBarConnectedPreview: "Connected-Vorschau",
automationsKeysCalloutTitle: "Dienstkonten und API-Schlüssel werden hier nicht erstellt",
automationsKeysCalloutBody: "Nutzen Sie den Tab „API-Schlüssel & Zugriff“, um Dienstkonten anzulegen, API-Schlüssel auszugeben, das Gateway zu prüfen und Endpunkte zu kopieren. Dieser Tab dient nur Ereignis-Trigger-Rezepten und dem Ausführungsverlauf.",
automationsKeysCalloutCta: "API-Schlüssel & Zugriff öffnen",
apiExplorerLead: "Schreibgeschützte Referenz der öffentlichen API. „Ausprobieren“ ist in dieser Ansicht deaktiviert, damit Ihre Zugangsdaten keinen beliebigen Ursprüngen (CORS) offengelegt werden. Nutzen Sie API-Schlüssel & Zugriff → Verbindung überprüfen mit Ihrer Sitzung oder testen Sie mit einem Dienstkontoschlüssel aus demselben Bildschirm.",
apiExplorerServerDescription: "AssetWRX-Workspace-API",
apiExplorerGoVerify: "API-Schlüssel & Zugriff öffnen, um die Verbindung zu prüfen",
apiExplorerBack: "Zurück",
apiExplorerPhoneTitle: "Am besten auf einem größeren Bildschirm",
apiExplorerPhoneBody: "Die interaktive API-Referenz ist für Tablet oder Desktop ausgelegt. Öffnen Sie diese Seite dort, um Endpunkte und Modelle zu durchsuchen. API-Schlüssel verwalten Sie weiterhin oben, und die Basis-URL kopieren Sie unten.",
apiExplorerBaseUrlLabel: "Basis-URL",
apiExplorerCovers: "Umfasst Anlagen und Orte, Standorte, Checklisten, Inspektionen und ihre Termine, Aufträge, Wartungspläne und -programme, Kontakte, Teams, Erkenntnisse, Dateien, Webhooks, Automatisierung, verbundene Geräte, Power BI und KI-Agenten. Standorte, Checklisten, Termine, Wartung und Teams sind nur lesbar.",
apiExplorerSectionNeeds: "Tarif-Schalter: {{names}}.",
apiExplorerSectionOff: "Nicht in Ihrem Tarif: {{names}} ist für diesen Arbeitsbereich ausgeschaltet.",
apiExplorerNotInPlan: "Nicht in Ihrem Tarif, daher werden diese Aufrufe abgelehnt: {{sections}}.",
handbookTitleAutomation: "Automatisierungsleitfaden (in der App)",
handbookTitleIntegrations: "API- & Verbindungsleitfaden (in der App)",
handbookLead: "Dieser Inhalt wird der App aus dem maßgeblichen Markdown im Produkt-Repository beigefügt.",
handbookOpenHosted: "Gehostete Kopie öffnen",
handbookCopyMarkdown: "Markdown kopieren",
handbookCopyDoneTitle: "Kopiert",
handbookCopyDoneBody: "Das Markdown des Leitfadens wurde in Ihre Zwischenablage kopiert.",
handbookCopyFailedTitle: "Kopieren fehlgeschlagen",
handbookCopyFailedBody: "Auf diesem Gerät konnte nicht in die Zwischenablage kopiert werden.",
handbookOpenFailedTitle: "Link konnte nicht geöffnet werden",
handbookOpenFailedBody: "Überprüfen Sie die URL der gehosteten Dokumentation in Ihren Workspace-Umgebungseinstellungen.",
docsFallbackTitle: "Dokumentationslink",
docsFallbackAutomationIntro: "Die gehostete Dokumentation ist noch nicht konfiguriert. Sie können diese internen Referenzpfade für Ihre Unterlagen kopieren oder mit der für Integrationen zuständigen Person teilen.",
docsFallbackApiIntro: "Die gehostete Dokumentation ist noch nicht konfiguriert. Sie können diese internen Referenzpfade für Ihre Unterlagen kopieren oder mit der für Integrationen zuständigen Person teilen.",
docsFallbackCopy: "Referenzpfade kopieren",
docsFallbackClose: "Schließen",
docsPathAutomation: "Automatisierungsleitfaden (interne Referenz)",
docsPathApi: "API & Integrationen (interne Referenz)",
docsPathOpenApiYaml: "OpenAPI-Vertrag (interne Referenz)",
showAdvancedDetails: "Erweiterte Details anzeigen",
hideAdvancedDetails: "Erweiterte Details ausblenden",
loadingContracts: "Integrationsverträge werden geladen…",
retryLoad: "Erneut laden",
navSectionMain: "Module",
navSectionAutomation: "Ereignis-Trigger-Ansichten",
guidedBadge: "Geführt",
recipeListTitle: "Rezepte in diesem Workspace",
recipeListSubtitle: "Aktivieren, pausieren, duplizieren, archivieren, mit optionalem JSON ausführen, eingehende Tokens rotieren und aus dem Verlauf erneut versuchen.",
recipeNoActions: "keine Aktionen",
recipeListEmpty: "Noch keine Rezepte.",
recipePause: "Pausieren",
recipePaused: "Rezept pausiert",
recipeActivate: "Aktivieren",
recipeActive: "Rezept aktiv",
recipeManualRun: "Manueller Lauf",
recipeDuplicate: "Duplizieren",
recipeDuplicated: "Rezept dupliziert",
recipeRotateToken: "Token rotieren",
recipeTokenRotated: "Webhook-Token rotiert",
recipeArchive: "Archivieren",
recipeArchived: "Rezept archiviert",
guidedWizard: {
title: "Geführte Automatisierung",
subtitle: "Wählen Sie eine Checkliste, füllen Sie einige Felder aus und erstellen Sie dann einen serverseitig gespeicherten Entwurf. Die erweiterte Rezeptbearbeitung finden Sie weiterhin unter Ereignis-Trigger → Experteneditor.",
publicApiLead: "Alle Läufe werden in Ihrem Workspace über die öffentliche API ausgeführt; in der App wird nichts simuliert.",
apisShortcutLabel: "Dienstkonten oder API-Schlüssel anlegen oder anzeigen",
apisShortcutA11y: "API-Schlüssel & Zugriff öffnen, um Dienstkonten und API-Schlüssel zu verwalten",
pillType: "Typ",
pillBasics: "Grundlagen",
pillReview: "Prüfung",
pillArtifacts: "Testen & speichern",
pillDone: "Fertig",
next: "Weiter",
back: "Zurück",
categoryWorkflow: "Alltägliche Arbeitsabläufe",
categoryInspection: "Inspektionen",
categoryJob: "Aufträge",
categoryAssetSync: "Anlagensynchronisierung",
categoryInboundWebhook: "Eingehende Webhooks",
categoryScheduled: "Geplant",
categoryOutbound: "Tests und Benachrichtigungen",
fieldName: "Name",
placeholderName: "Kurzer interner Name",
fieldDescription: "Beschreibung (optional)",
placeholderDescription: "Wer dies nutzt und welches System es empfängt",
fieldForwardUrl: "Weiterleiten an HTTPS-URL",
fieldDestinationUrl: "Ziel-HTTPS-URL",
fieldSigningSecret: "Signaturschlüssel (optional)",
placeholderSigningSecret: "Leer lassen, wenn Ihr Empfänger HMAC nicht überprüft",
fieldFilterStatus: "Nur wenn Prüfstatus gleich ist (optional)",
placeholderFilterStatus: "z. B. completed — leer lassen, um bei jeder Aktualisierung zu senden",
fieldAssetEvent: "Anlagenereignis",
fieldIntervalMinutes: "Intervall (Minuten)",
fieldJobIdPath: "Auftrags-ID-Feld im JSON-Body",
fieldStatusPath: "Statusfeld im JSON-Body",
reviewWhen: "Wenn: ",
reviewDo: "Aktion: ",
reviewNeedFix: "Beheben Sie Fehler unter „Grundlagen“, um das zusammengestellte Rezept zu sehen.",
artifactsLead: "Kopieren Sie das Vertrags-YAML oder Beispiel-JSON für Partner. Wenn Sie bereit sind, erstellen Sie einen Entwurf — aktivieren Sie dann das Rezept und verwenden Sie „Manueller Lauf“ mit JSON aus der Liste unten.",
copyYaml: "Vertrags-YAML kopieren",
manualRunHelp: "Hilfe zum manuellen Lauf",
copySampleEvent: "Beispiel-JSON für Domain-Ereignis kopieren",
copyManualInput: "Beispiel-Eingabe für manuellen Lauf kopieren",
saving: "Wird gespeichert…",
createDraftContinue: "Entwurf erstellen und weiter",
draftCreatedAlert: "Automatisierungsentwurf erstellt",
turnedOnAlert: "Automatisierung eingeschaltet",
turnOn: "Einschalten",
saveDraft: "Als Entwurf speichern",
copiedTitle: "Kopiert",
copiedYamlBody: "Vertrags-YAML in die Zwischenablage kopiert.",
copiedEventBody: "Beispiel-Ereignis-JSON kopiert.",
copiedManualBody: "Verwenden Sie diesen Body als Eingabe für manuelle Läufe nach der Aktivierung.",
successTitle: "Entwurf gespeichert",
successBody: "Ihr Rezept erscheint in der Liste unten. Aktivieren Sie es, sobald Sie bereit sind, und testen Sie es dann mit „Manueller Lauf“ und JSON.",
successBodyActive: "Es ist eingeschaltet. Jeder Lauf wird im Verlauf dieser Automatisierung angezeigt.",
createAnother: "Weiteres erstellen",
alertNeedTypeTitle: "Typ auswählen",
alertNeedTypeBody: "Wählen Sie eine Automatisierungsvorlage aus, um fortzufahren.",
alertInvalidTitle: "Felder prüfen",
alertInvalidBody: "Füllen Sie die erforderlichen Felder aus, um fortzufahren.",
manualHarnessTitle: "Manuelle Testumgebung",
manualHarnessBodyGeneric: "Erstellen Sie einen Entwurf „Manueller Test-Webhook“, aktivieren Sie ihn und verwenden Sie dann „Manueller Lauf“ in der Rezeptzeile mit dem Beispiel-JSON.",
manualHarnessCreateFirstTitle: "Zuerst erstellen",
manualHarnessCreateFirstBody: "Speichern Sie diese Automatisierung als Entwurf über „Entwurf erstellen und weiter“, aktivieren Sie sie dann und verwenden Sie „Manueller Lauf“ in der Rezeptzeile mit dem Beispiel-JSON.",
},
manualRunModal: {
title: "Manueller Lauf",
inputLabel: "Optionale JSON-Eingabe (Objekt)",
run: "Lauf einreihen",
cancel: "Abbrechen",
errorInvalidJson: "Geben Sie gültiges JSON ein oder lassen Sie das Feld für {} leer.",
errorNotObject: "Die Eingabe muss ein JSON-Objekt sein (kein Array).",
successTitle: "Manueller Lauf eingereiht",
successBody: "Lauf-ID: {{id}}\nStatus: {{status}}",
goToRuns: "Laufverlauf öffnen",
},
accessWizard: {
pageTitle: "API-Schlüssel & Zugriff",
pageSubtitle: "Übersicht, Gateway überprüfen, Schlüssel verwalten, neuen Schlüssel erstellen, eingehende Automatisierungen prüfen und dann die REST-Basis-URL und -Pfade kopieren. Nichts hier umgeht Ihre Workspace-Sicherheit.",
pillPurpose: "Übersicht",
pillVerify: "Überprüfen",
pillAccounts: "Vorhandene Schlüssel",
pillCreate: "Neuer Schlüssel",
pillInbound: "Eingehend",
pillEndpoints: "Endpunkte",
purposeTitle: "Was Sie verbinden können",
purposeBody: "REST-API-Schlüssel ermöglichen vertrauenswürdigen Systemen das Lesen und Schreiben von Workspace-Daten. Ausgehende Plattform-Webhooks werden separat im Verbindungsleitfaden konfiguriert. Eingehende Rezept-URLs dienen als Automatisierungs-Trigger.",
openHandbook: "Vollständigen Verbindungsleitfaden öffnen",
verifyTitle: "Workspace-API überprüfen (Sitzung)",
verifyLead: "Bestätigt, dass dasselbe Gateway, das die App für die Integrationsverwaltung nutzt, mit Ihrer aktuellen Anmeldung erreichbar ist.",
verifyAppLoginVsApiKeyTitle: "App-Anmeldung vs. API-Schlüssel",
verifyAppLoginVsApiKeyBody: "In dieser App melden Sie sich mit Ihrem Benutzerkonto an (dieselbe Sitzung wie im Rest von AssetWRX). API-Schlüssel sind nur für andere Systeme und Skripte, die die REST-API aufrufen — sie ersetzen keine Anmeldung in der App.",
verifyConnection: "Verbindung überprüfen",
verifying: "Wird überprüft…",
sessionVerifyOk: "Erreichbar. Workspace {{workspaceId}} · Principal: {{principal}}",
accountsListTitle: "Vorhandene Dienstkonten",
accountsListLead: "Schlüssel werden im Ruhezustand mit SHA-256 gehasht; der Klartext wird nur einmal bei Erstellung oder Rotation angezeigt. Aktualisieren Sie die Liste, nachdem Sie auf einem anderen Gerät einen Schlüssel erstellt haben.",
accountsListSecretCalloutTitle: "Warum der vollständige Schlüssel hier nicht erscheint",
accountsListSecretCalloutBody: "Serverseitig wird nur ein Hash gespeichert. Der vollständige Geheimtext erscheint einmal im Dialog beim Erstellen oder Rotieren — kopieren Sie ihn dann in einen Passwortmanager. Unten sehen Sie nur Kontonamen und Berechtigungen. Wenn Sie den Dialog ohne Speichern geschlossen haben, nutzen Sie „Schlüssel rotieren“ für ein neues Geheimnis.",
accountsAdminErrorHint: "Nur Workspace-Administratoren können Dienstkonten und API-Schlüssel auflisten oder erstellen. Melden Sie sich mit einem Admin-Konto an, oder bitten Sie einen Inhaber, Ihnen Admin-Rechte zu geben.",
refreshList: "Liste aktualisieren",
refreshLoading: "Wird geladen…",
lastUsed: "Zuletzt verwendet {{when}}",
neverUsed: "Noch nicht verwendet",
rotatedOn: "Schlüssel rotiert {{when}}",
revokedOn: "Entzogen {{when}}",
rotateKey: "Schlüssel rotieren",
revoke: "Entziehen",
revoked: "Entzogen",
noAccounts: "Noch keine Dienstkonten.",
createTitle: "Dienstkonto erstellen",
createLead: "Wählen Sie einen Namen, eine optionale Beschreibung, Berechtigungen und einen optionalen Ablauf des Schlüssels. Sie sehen den vollständigen Schlüssel nur einmal — speichern Sie ihn in einem Tresor.",
endpointsTitle: "REST-Gateway & Pfade",
endpointsLead: "Alle versionierten REST-Aufrufe laufen über diese Basis-URL. Fügen Sie Pfade aus dem Vertrag an (zum Beispiel /v1/assets). Eingehende Automatisierungs-URLs sind separat und werden im Schritt „Eingehend“ aufgeführt.",
endpointsBaseLabel: "Gateway-Basis-URL",
endpointsCopyBase: "Basis-URL kopieren",
endpointsCopiedTitle: "Kopiert",
endpointsCopiedBody: "Gateway-Basis-URL in die Zwischenablage kopiert.",
endpointsExamplesTitle: "Beispiele (relativ zur Basis)",
endpointsExampleStatus: "GET /v1/status — Zustand der Workspace-API (erfordert status:read für API-Schlüssel)",
endpointsExampleAssets: "GET /v1/assets — Anlagen auflisten (erfordert assets:read)",
endpointsExampleInbound: "Eingehende Automatisierungen verwenden rezeptspezifische HTTPS-URLs aus dem Schritt „Eingehend“, nicht diese Basis-URL.",
endpointsExampleDocs: "Jeder Pfad, Abfrageparameter und Body-Aufbau ist in der Live-OpenAPI-Referenz enthalten.",
endpointsAuthHint: "Von anderen Systemen aus: Senden Sie den Header apikey: <Ihr veröffentlichbarer AssetWRX-Schlüssel> und Authorization: Bearer <Ihr API-Schlüssel des Dienstkontos>. Diese App verwendet stattdessen Ihre Anmeldesitzung.",
endpointsOpenReference: "Live-API-Referenz öffnen",
fieldName: "Name",
fieldDescription: "Beschreibung (optional)",
fieldExpiry: "Erster Schlüssel läuft ab am (optionales ISO-Datum)",
placeholderName: "Nächtliche ERP-Synchronisierung",
placeholderDescription: "Interner Hinweis",
saving: "Wird gespeichert…",
createShowKey: "Erstellen & Schlüssel anzeigen",
inboundTitle: "Eingehende Rezept-Endpunkte",
inboundLead: "Wird für Rezepte angezeigt, die den eingehenden Webhook-Trigger verwenden. URLs und Secrets erscheinen nach der Aktivierung am Rezept.",
inboundToken: "Schlüssel {{prefix}}…{{last}}",
inboundEmpty: "Erstellen Sie ein Rezept mit dem eingehenden Webhook-Trigger, um einen tokenisierten Endpunkt zu generieren.",
keyVerifyOk: "Testanfrage mit diesem Schlüssel erfolgreich (GET /v1/status).",
keyVerifyFail: "Schlüssel konnte nicht mit GET /v1/status überprüft werden: {{message}}",
keyVerifySkipped: "Fügen Sie die Berechtigung „Workspace-Status“ (status:read) hinzu, um neue Schlüssel künftig automatisch zu überprüfen.",
keyRevealModalTitle: "Ihr neuer API-Schlüssel",
keyRevealModalLead: "Kopieren Sie dieses Geheimnis und speichern Sie es in einem Passwortmanager. Den vollständigen Schlüssel können Sie hier nicht erneut anzeigen.",
keyRevealCopy: "Schlüssel kopieren",
keyRevealSaved: "Ich habe ihn gespeichert",
keyRevealMissingFromServer: "Der Server hat keinen Schlüssel zurückgegeben. Versuchen Sie es erneut oder prüfen Sie die Edge-Function-Logs.",
keyRevealCopiedTitle: "Kopiert",
keyRevealCopiedBody: "API-Schlüssel in die Zwischenablage kopiert.",
},
mcpWizard: {
pageTitle: "Workspace-MCP-Server",
pageSubtitle: "Verbinden Sie genehmigte Remote-MCP-Server über HTTPS, speichern Sie Secrets verschlüsselt, führen Sie die Ermittlung über das Backend aus und legen Sie dann fest, welche Tools und Ressourcen der Assistent vorschlagen darf.",
flowLabel: "Geführte Einrichtung",
pillIntro: "Übersicht",
pillServer: "Dienst",
pillCredentials: "Geheimnisse",
pillVerify: "Testen & ermitteln",
pillCatalog: "Positivliste",
pillHistory: "Verlauf",
loading: "MCP-Konfiguration wird geladen…",
loadError: "MCP-Konfiguration konnte nicht geladen werden.",
detailLoadError: "Tools und Ressourcen für diesen Server konnten nicht geladen werden.",
introTitle: "Was Sie einrichten",
introLead: "Mit dem Model Context Protocol (MCP) kann der operative Assistent externe Tools aufrufen und externe Ressourcen lesen, nachdem Sie jeden Vorschlag bestätigt haben. Dieser Workspace führt eine strikte Positivliste.",
introWhatTitle: "Einschränkungen von Version 1",
introWhatBody: "Es werden nur Remote-HTTP-JSON-RPC-Endpunkte unterstützt. Zugangsdaten werden serverseitig verschlüsselt; die App erhält nach dem Speichern niemals Klartext-Secrets. Ermittlung und Aufrufe laufen immer über die öffentliche API-Edge-Function.",
introStepsTitle: "Führen Sie diese Schritte in dieser Reihenfolge aus",
introStep1: "Registrieren Sie den Servernamen und die von Ihrem Anbieter dokumentierte HTTPS-Basis-URL.",
introStep2: "Speichern Sie Zugangsdaten, wenn der Endpunkt einen Bearer-Token, API-Schlüssel-Header oder benutzerdefinierten Header erfordert.",
introStep3: "Testen Sie die Verbindung und führen Sie dann die Ermittlung aus, damit Tools und Ressourcen im Katalog erscheinen.",
introStep4: "Aktivieren Sie nur die Tools und Ressourcen, die dieser Workspace jemals aufrufen soll.",
introStep5: "Aktivieren Sie optional „Assistent“ pro Zeile, damit der Planer dieses Tool oder diese Ressource vorschlagen kann (Sie bestätigen weiterhin vor der Ausführung).",
introStep6: "Prüfen Sie den Aufrufverlauf für Audits und Problembehandlung.",
serverListTitle: "Server auswählen oder hinzufügen",
serverListLead: "Wählen Sie eine Karte zum Bearbeiten aus oder verwenden Sie „MCP-Server hinzufügen“ für eine neue Zeile und speichern Sie dann unten.",
serverCardCounts: "Tools: {{tools}} · Ressourcen: {{resources}}",
addServer: "MCP-Server hinzufügen",
serverFormTitle: "Serverdetails",
serverFormLead: "Fügen Sie die exakte MCP-Endpunkt-URL Ihres Anbieters ein. Sie muss HTTPS verwenden — nutzen Sie das Beispielformat unten, falls Sie unsicher sind.",
fieldName: "Name",
fieldDescription: "Beschreibung (optional)",
fieldBaseUrl: "Basis-URL (HTTPS)",
fieldBaseUrlPlaceholder: "https://mcp.example.com/v1",
fieldBaseUrlHint: "Muss mit https:// beginnen. Verwenden Sie den vollständigen Pfad, den Ihr MCP-Host dokumentiert (oft /mcp, /sse oder /v1). HTTP und bloße Hostnamen werden nicht unterstützt.",
alertBaseUrlHttpsTitle: "HTTPS-URL erforderlich",
alertBaseUrlHttpsBody: "Die MCP-Basis-URL muss mit https:// beginnen. Beispiel: https://mcp.example.com/v1",
invalidBaseUrlFormat: "Geben Sie eine vollständige URL einschließlich https:// ein, zum Beispiel https://mcp.example.com/v1",
fieldTimeoutMs: "Zeitlimit (ms)",
fieldMaxPayload: "Maximale Payload-Größe (Bytes)",
fieldHeaderName: "Headername",
fieldSecret: "Geheimnis",
secretPlaceholderNew: "Geben Sie das Secret einmal ein, um es zu verschlüsseln",
secretPlaceholderRotate: "Geben Sie ein neues Secret ein, um den gespeicherten Wert zu rotieren",
saving: "Wird gespeichert…",
updateServer: "Server aktualisieren",
createServer: "Server erstellen",
serverSavedTitle: "MCP-Server gespeichert",
serverSavedBody: "{{name}} wurde gespeichert. Fahren Sie mit „Secrets“ fort, wenn der Endpunkt eine Authentifizierung benötigt.",
serverSaveFailedTitle: "Speichern fehlgeschlagen",
serverSaveFailed: "MCP-Server konnte nicht gespeichert werden.",
credentialsTitle: "Verschlüsselte Zugangsdaten",
credentialsLead: "Legen Sie fest, wie sich das Backend beim MCP-Server authentifiziert. Verwenden Sie „Keine“ nur für Hosts, die kein Secret erfordern.",
credentialsNeedServer: "Speichern Sie im vorherigen Schritt einen Server, bevor Sie Zugangsdaten hinzufügen.",
credentialStored: "Gespeichert: {{type}} {{prefix}}…{{last}}",
saveCredentials: "Zugangsdaten speichern",
credentialsSavedTitle: "Zugangsdaten aktualisiert",
credentialsSavedBody: "Secrets werden im Ruhezustand verschlüsselt. Danach werden der App nur maskierte Metadaten zurückgegeben.",
credentialsSaveFailedTitle: "Aktualisierung der Zugangsdaten fehlgeschlagen",
credentialsSaveFailed: "Zugangsdaten konnten nicht gespeichert werden.",
noSecretStored: "Kein Secret gespeichert",
verifyTitle: "Verbindung testen und ermitteln",
verifyLead: "Der Test führt einen einfachen Initialisierungs-Handshake durch. Die Ermittlung listet Tools und Ressourcen auf, damit Sie sie genehmigen können.",
verifyOrderTitle: "Empfohlene Reihenfolge",
verifyOrderBody: "Führen Sie zuerst „Verbindung testen“ aus. Bei Erfolg führen Sie „Metadaten ermitteln“ aus und wechseln dann zur Positivliste, um Einträge zu aktivieren.",
verifyNeedServer: "Speichern Sie zuerst einen Server und kehren Sie dann hierher zurück.",
testConnection: "Verbindung testen",
discoverMetadata: "Metadaten ermitteln",
testOkTitle: "Verbindungstest erfolgreich",
testOkBody: "Abgeschlossen in {{ms}} ms.",
discoverOkTitle: "Ermittlung abgeschlossen",
discoverOkBody: "{{tools}} Tools und {{resources}} Ressourcen gefunden.",
testFailedTitle: "Verbindungstest fehlgeschlagen",
discoverFailedTitle: "Ermittlung fehlgeschlagen",
actionFailedGeneric: "Der Vorgang konnte nicht abgeschlossen werden.",
catalogTitle: "Positivliste für Tools und Ressourcen",
catalogLead: "Der Workspace steuert, ob das Backend einen Eintrag überhaupt aufrufen darf. Die Assistent-Schalter fügen zusätzlich die Sichtbarkeit für den Planer hinzu.",
catalogNeedServer: "Speichern Sie einen Server und führen Sie die Ermittlung aus, bevor Sie den Katalog verwalten.",
toolsHeading: "Werkzeuge",
resourcesHeading: "Ressourcen",
noTools: "Noch keine Tools ermittelt. Führen Sie im vorherigen Schritt „Metadaten ermitteln“ aus.",
noResources: "Noch keine Ressourcen ermittelt. Führen Sie im vorherigen Schritt „Metadaten ermitteln“ aus.",
workspaceOn: "Workspace an",
workspaceOff: "Workspace aus",
assistantOn: "Assistent an",
assistantOff: "Assistent aus",
historyTitle: "Aufrufverlauf",
historyLead: "Jeder Aufruf erfasst Ziel, Zeitpunkt, Status und bereinigte Payload-Vorschauen.",
noInvocations: "Noch keine MCP-Aufrufe erfasst.",
invocationMeta: "Dauer {{ms}} ms · {{when}}",
maskedLine: "Letzte Zugangsdaten-Maskierung: {{mask}}",
alertNeedServerTitle: "Zuerst einen Server speichern",
alertNeedServerBody: "Erstellen oder wählen Sie einen Server, füllen Sie die erforderlichen Felder aus und tippen Sie auf „Server erstellen“ oder „Server aktualisieren“, bevor Sie fortfahren.",
alertServerFieldsTitle: "Erforderliche Felder prüfen",
alertServerFieldsBody: "Geben Sie einen Anzeigenamen und eine HTTPS-Basis-URL ein, bevor Sie fortfahren.",
alertNoServerTitle: "Kein Server ausgewählt",
alertNoServerBody: "Wählen oder erstellen Sie einen Server, bevor Sie Zugangsdaten speichern.",
toolUpdateFailedTitle: "Aktualisierung des Tools fehlgeschlagen",
toolUpdateFailed: "MCP-Tool konnte nicht aktualisiert werden.",
resourceUpdateFailedTitle: "Aktualisierung der Ressource fehlgeschlagen",
resourceUpdateFailed: "MCP-Ressource konnte nicht aktualisiert werden.",
},
editor: {
  saved: "Automatisierung aktualisiert",
  saveFailed: "Speichern nicht möglich",
  title: "Automatisierung bearbeiten",
  notGuidedTitle: "Keine geführte Automatisierung",
  notGuidedDesc: "Diese wurde im erweiterten Editor erstellt. Bearbeiten Sie sie dort.",
  save: "Speichern",
},
guidedForm: {
  severityLabel: "Auslösen bei",
  severityAny: "Jedes Problem",
  severityUrgent: "Nur dringende Probleme",
  checklistLabel: "Nur für diese Checkliste",
  anyChecklist: "Jede Checkliste",
  assignLabel: "Auftrag zuweisen an",
  nobodyYet: "Noch niemand",
  urgencyLabel: "Dringlichkeit des Erneuerungsauftrags",
  urgencyDefault: "Normal",
  urgencyHigh: "Hoch",
  urgencyUrgent: "Dringend",
  thresholdLabel: "Aufträge ab diesem Wert ({{currency}})",
  approverLabel: "Wer sie freigibt",
  choosePerson: "Person auswählen",
  daysLabel: "Unbeantwortet seit",
  daysOption_one: "{{count}} Tag",
  daysOption_other: "{{count}} Tage",
  assetCreated: "Erstellt",
  assetUpdated: "Aktualisiert",
  assetDeleted: "Gelöscht",
  titlePathLabel: "Der Auftragstitel stammt aus diesem Feld im JSON",
  unknownChoice: "Nicht mehr im Arbeitsbereich",
  wholeTeam: "Ganzes Team",
  notifyLabel: "Benachrichtigen",
  nobody: "Niemand",
  choosePersonOrTeam: "Person oder Team auswählen",
  close: "Schließen",
  search: "Suchen…",
  noMatch: "Keine Treffer.",
},
},
connectedAssets: {
title: "Verbundene Anlagen",
lead: "IoT-Connectors und Live-Telemetrie erscheinen hier. Dieser Bereich ist für zukünftige Funktionen reserviert.",
backToIntegrations: "Zurück zu den Automatisierungen",
moreTitle: "Umfang und Roadmap",
moreSummary: "Connectors, Gerätestatus und Automatisierungs-Anbindungen.",
moreBody: "Verbundene Anlagen zeigen Live-Messwerte, letzte Aktivität und Verknüpfungen zu Inspektionen und Aufträgen, sobald Integrationen im Workspace aktiv sind. Nutzen Sie Automatisierungen, um Connectors bereitzustellen und Datenzugriff zu steuern.",
showMore: "Mehr anzeigen",
showLess: "Weniger anzeigen",
},
apiAccess: {
catalogScopesLabel: "API-Zugriffsbereiche",
noScopes: "Keine Zugriffsbereiche ausgewählt",
fullAccessChip: "Vollständiger API-Zugriff",
scopesSectionTitle: "Was dieser Schlüssel nutzen kann",
scopesSectionHint: "Wählen Sie ein Starterpaket für gängige Tools und feinjustieren Sie dann mit den Kontrollkästchen. Aktivieren Sie nur, was Ihre Integration benötigt.",
presetsLabel: "Starterpakete",
preset_starter_title: "Berichte & Listen",
preset_starter_subtitle: "Workspace-Status, Anlagen, Prüfungen und Aufträge lesen — geeignet für Dashboards und schreibgeschützte Synchronisierung.",
preset_field_title: "Außendienstbetrieb",
preset_field_subtitle: "Fügt das Erstellen und Aktualisieren von Anlagen, Kontakten, Prüfungen und Aufträgen hinzu — typisch für mobile Tools oder Team-Tools.",
preset_automation_title: "Automatisierungen & Ereignisse",
preset_automation_subtitle: "Umfasst Rezepte, den Automatisierungskatalog und das Lesen von Ereignissen — für Zapier-ähnliche Workflows und Webhooks.",
preset_full_title: "Alles (Administrator)",
preset_full_subtitle: "Volle API-Leistung einschließlich GraphQL und Verwaltung anderer Schlüssel. Nur für vertrauenswürdige Serversoftware verwenden.",
preset_read_only_title: "Nur Lesen",
preset_read_only_subtitle: "Workspace-Status, Anlagen, Kontakte, Prüfungen, Aufträge und den Ereignis-Feed anzeigen. Es kann nichts geändert werden.",
preset_power_bi_title: "Power BI",
preset_power_bi_subtitle: "Anlagen, Prüfungen und Aufträge über den OData-Feed lesen. Nichts kann geändert werden.",
preset_power_automate_title: "Power Automate",
preset_power_automate_subtitle: "Was der Power-Automate-Connector braucht: Anlagen lesen, Aufträge und Prüfungen lesen und anlegen, Flows über Ereignisse starten.",
preset_asset_operations_title: "Anlagenbetrieb",
preset_asset_operations_subtitle: "Anlagen und Kontakte erstellen und aktualisieren, mit Lesezugriff auf Checklisten — um ein Anlagenregister synchron zu halten.",
preset_inspections_title: "Prüfungen",
preset_inspections_subtitle: "Prüfungen erstellen und aktualisieren, mit Lesezugriff auf Anlagen, Aufträge und Checklisten — für Prüf-Tools.",
preset_wrx_operations_title: "WRX-Betrieb",
preset_wrx_operations_subtitle: "Vollständiger Lese- und Schreibzugriff auf Anlagen, Kontakte, Prüfungen und Aufträge (WRX) sowie den Ereignis-Feed — für operative Systeme.",
preset_full_integration_title: "Vollständige Integration",
preset_full_integration_subtitle: "Vollständiger API-Zugriff einschließlich GraphQL und Schlüsselverwaltung. Nur für vertrauenswürdige Serversoftware verwenden.",
preset_custom_access_title: "Benutzerdefiniert",
preset_custom_access_subtitle: "Wählen Sie genau die Zugriffsbereiche aus, die diese Verbindung benötigt.",
preset_ai_read_title: "Anlageninformationen lesen",
preset_ai_read_subtitle: "Erlauben Sie dem KI-Agenten, Anlagen, Kontakte, Prüfungen und Aufträge zu lesen. Er kann keine Änderungen vornehmen.",
preset_ai_inspection_title: "Prüfassistent",
preset_ai_inspection_subtitle: "Erlauben Sie dem KI-Agenten, Anlagen und Checklisten zu lesen sowie Prüfungen zu erstellen oder zu aktualisieren.",
preset_ai_wrx_title: "WRX-Assistent",
preset_ai_wrx_subtitle: "Erlauben Sie dem KI-Agenten, Anlagen, Kontakte, Prüfungen und Aufträge (WRX) zu lesen und zu aktualisieren.",
preset_ai_operations_title: "Betriebsassistent",
preset_ai_operations_subtitle: "Vollständiger operativer Zugriff für den KI-Agenten, einschließlich Automatisierung und Connected-Ereigniskontext.",
preset_custom_ai_title: "Benutzerdefiniert",
preset_custom_ai_subtitle: "Wählen Sie genau aus, welche Tools und Informationen diese KI-Verbindung nutzen kann.",
group_overview: "Übersicht & Assistent",
group_records: "Anlagen, Kontakte, Prüfungen & Aufträge",
group_events: "Webhooks & Ereignisse",
group_automation: "Automatisierungs-Builder",
group_connected: "Verbundene Quellen, Ereignisse & Regeln",
group_advanced: "Erweitert & Schlüsselverwaltung",
scope_status_read: "Workspace-Status",
scope_dashboard_read: "Dashboard-Daten",
scope_dashboards_read: "Gespeicherte Dashboards",
scope_assistant_context_read: "Assistentenkontext (Lesen)",
scope_assets_read: "Anlagen anzeigen",
scope_assets_write: "Anlagen erstellen & bearbeiten",
scope_contacts_read: "Kontakte anzeigen",
scope_contacts_write: "Kontakte erstellen & bearbeiten",
scope_inspections_read: "Prüfungen anzeigen",
scope_inspections_write: "Prüfungen erstellen & bearbeiten",
scope_jobs_read: "Aufträge anzeigen",
scope_jobs_write: "Aufträge erstellen & bearbeiten",
scope_templates_read: "Checklisten anzeigen",
scope_templates_write: "Checklisten erstellen und bearbeiten",
scope_mcp_read: "KI-Einstellungen (MCP) ansehen",
scope_mcp_write: "KI-Einstellungen (MCP) verwalten",
scope_mcp_invoke: "KI-Werkzeuge (MCP) verwenden",
scope_connected_sources_read: "Verbundene Quellen ansehen",
scope_connected_sources_write: "Verbundene Quellen verwalten",
scope_connected_events_read: "Verbundene Ereignisse ansehen",
scope_connected_events_write: "Verbundene Ereignisse senden",
scope_connected_rules_read: "Verbundene Regeln ansehen",
scope_connected_rules_write: "Verbundene Regeln verwalten",
scope_webhooks_read: "Ausgehende Webhooks anzeigen",
scope_webhooks_write: "Ausgehende Webhooks verwalten",
scope_events_read: "Ereignis-Feed lesen",
scope_graphql_read: "GraphQL (Lesen)",
scope_graphql_write: "GraphQL (Schreiben)",
scope_service_accounts_read: "API-Schlüssel & Dienstkonten anzeigen",
scope_service_accounts_write: "API-Schlüssel & Dienstkonten verwalten",
scope_automation_catalog_read: "Automatisierungskatalog anzeigen",
scope_automation_recipes_read: "Rezepte anzeigen",
scope_automation_recipes_write: "Rezepte erstellen & bearbeiten",
scope_automation_runs_read: "Rezeptläufe anzeigen",
scope_automation_actions_write: "Automatisierungsaktionen ausführen",
alertNameTitle: "Name erforderlich",
alertNameBody: "Geben Sie einen kurzen Namen ein, damit Ihr Team weiß, wofür diese Integration dient.",
alertScopesTitle: "Wählen Sie mindestens einen Bereich aus",
alertScopesBody: "Wählen Sie ein Starterpaket oder aktivieren Sie einen oder mehrere Zugriffsbereiche.",
alertExpiryTitle: "Ablaufdatum prüfen",
alertExpiryBody: "Verwenden Sie ein gültiges Datum und eine gültige Uhrzeit, oder lassen Sie den Ablauf leer.",
alertStoreKeyTitle: "Kopieren Sie jetzt Ihren API-Schlüssel",
alertStoreKeyBody: "Dies ist das einzige Mal, dass der vollständige Schlüssel angezeigt wird. Speichern Sie ihn in einem Passwort-Manager oder Tresor.\n\n{{key}}",
},
defaults: {
  memberNotice: "Nur ein Admin kann Sprache und Zeitzone des Arbeitsbereichs ändern. Ihre eigenen finden Sie unter Einstellungen.",
  saveFailedBody: "Diese Änderung wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  saveFailedTitle: "Nicht gespeichert",
  currencyHint: "Gilt für Kosten, die Sie eintragen. Diese Währung ist Ihre eigene, nicht die des Arbeitsbereichs; ein Team kann eine eigene festlegen.",
regionalSummary: "Regionale Standardeinstellungen",
regionalBody: "Workspace-Standards gelten, wenn ein Teammitglied Sprache oder Zeitzone im Profil leer lässt. Persönliche Einstellungen haben immer Vorrang.",
workspaceDefaultLanguage: "Workspace-Standardsprache",
workspaceDefaultTimezone: "Workspace-Standardzeitzone",
effectiveLanguage: "Ihre tatsächlich verwendete Sprache",
effectiveTimezone: "Ihre tatsächlich verwendete Zeitzone",
notSet: "Nicht gesetzt",
openOrganization: "In Organisationsprofil bearbeiten",
loading: "Wird geladen…",
orgHint: "Standards werden im Organisationsprofil bearbeitet. Es gelten dieselben unterstützten Listen wie für persönliche Sprache und Zeitzone.",
categorySubtitle: "Standardeinstellungen für Ihren Arbeitsbereich. Sie werden für Inspektionen und Arbeitsaufträge verwendet; Teams können sie überschreiben.",
shareMethodEmail: "E-Mail",
languageOptionA11y: "Arbeitsbereichssprache {{label}}",
timezoneOptionA11y: "Workspace-Standardzeitzone",
currencyLabel: "Ihre Währung",
currencyOptionA11y: "Währung {{code}}",
shareMethodLabel: "Kommunikation (Freigabemethode)",
shareMethodOptionA11y: "Standardfreigabemethode {{label}}",
teamOverridesA11y: "Teameinstellungen und Überschreibungen öffnen",
teamOverridesLink: "Teameinstellungen und Überschreibungen",
searchTimezone: "Zeitzone suchen",
},
organization: {
defaultLanguageLabel: "Standardsprache",
timezoneLabel: "Standardzeitzone",
notSet: "Nicht gesetzt",
languageHelper: "Gilt, wenn ein Teammitglied keine persönliche Sprache festgelegt hat. Danach folgen die Gerätesprache (falls unterstützt) und Englisch (US).",
timezoneHelper: "Gilt, wenn ein Teammitglied keine persönliche Zeitzone festgelegt hat. Danach folgen die Gerätezeitzone und UTC.",
},
assetTypes: {
headerSubtitle: "Eigene Arten von Anlagen und Orten und die Angaben, die jede verlangt",
intro: "Fügen Sie die Arten von Anlagen hinzu, die Ihr Workspace betreut, etwa eine Kältemaschine, ein Hotelzimmer oder einen Aufzug, und die Angaben, die dafür ausgefüllt werden. Jede Anlage dieses Typs fragt dieselben Angaben ab.",
add: "Anlagentyp hinzufügen",
addTitle: "Neuer Anlagentyp",
editTitle: "Anlagentyp bearbeiten",
nameLabel: "Name",
namePlaceholder: "Zum Beispiel Kältemaschine oder Gästezimmer",
nameRequired: "Geben Sie dem Typ einen Namen",
kindLabel: "Es ist",
kindLocked_one: "Von {{count}} Anlage verwendet, daher bleibt die Art gleich.",
kindLocked_other: "Von {{count}} Anlagen verwendet, daher bleibt die Art gleich.",
descriptionLabel: "Beschreibung",
descriptionPlaceholder: "Optional. Was dieser Typ umfasst",
fieldsLabel: "Auszufüllende Angaben",
fieldsHint: "Jede Anlage dieses Typs zeigt diese auf ihrer Detailseite und im Erstellformular.",
fieldLabel: "Name der Angabe",
fieldPlaceholder: "Zum Beispiel Kältemittel oder Anzahl der Betten",
fieldKinds: {
text: "Text",
number: "Zahl",
date: "Datum",
choice: "Aus einer Liste wählen",
yes_no: "Ja oder nein",
},
optionsLabel: "Auswahlmöglichkeiten",
optionsPlaceholder: "Durch Kommas getrennt, zum Beispiel R410A, R32, R134a",
optionsRequired: "Fügen Sie mindestens eine Auswahl hinzu",
unitLabel: "Einheit",
unitPlaceholder: "Optional, zum Beispiel kW",
requiredLabel: "Pflichtangabe",
removeField: "Angabe entfernen",
addField: "Angabe hinzufügen",
cancel: "Abbrechen",
save: "Speichern",
saved: "Anlagentyp gespeichert",
saveFailedTitle: "Anlagentyp konnte nicht gespeichert werden",
saveFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
fieldCount_one: "{{count}} Angabe",
fieldCount_other: "{{count}} Angaben",
usedBy_one: "von {{count}} Anlage verwendet",
usedBy_other: "von {{count}} Anlagen verwendet",
archived: "Archiviert",
edit: "Bearbeiten",
archive: "Archivieren",
restore: "Wiederherstellen",
showArchived_one: "{{count}} archivierten Typ anzeigen",
showArchived_other: "{{count}} archivierte Typen anzeigen",
hideArchived: "Archivierte Typen ausblenden",
emptyTitle: "Noch keine eigenen Anlagentypen",
emptyBodyAdmin: "Fügen Sie einen hinzu, um einer Anlagenart eigene Angaben zu geben.",
emptyBody: "Ein Inhaber oder Admin kann Anlagentypen für den Workspace hinzufügen.",
archiveConfirmTitle: "Diesen Anlagentyp archivieren?",
archiveConfirmBody: "Anlagen, die ihn verwenden, behalten ihn und ihre Angaben. Er wird beim Hinzufügen neuer Anlagen nicht mehr angezeigt. Sie können ihn jederzeit wiederherstellen.",
},
industryPacks: {
  later: "Später",
  onboardingFailedBody: "Nicht alle fertigen Checklisten für Ihre Branche sind angekommen. Tippen Sie auf Erneut versuchen, um die Branchenpakete zu öffnen und sie hinzuzufügen.",
  onboardingFailedTitle: "Einige Checklisten wurden nicht hinzugefügt",
  openTemplates: "Checklisten öffnen",
  perAssetNote: "„Paket installieren“ fügt die Checklisten hinzu. Wartungspläne und Nachweise werden bei jeder passenden Anlage vorgeschlagen, damit Sie sie dort übernehmen können.",
title: "Branchenpakete",
headerSubtitle: "Checklisten für Anlagentypen, Checklisten und Pläne Ihrer Branche",
subtitle: "Ein kuratierter Startpunkt für das, was Sie verwalten. Nehmen Sie, was nützt, ändern Sie alles, entfernen Sie den Rest.",
disclaimer: "Vorschläge für den Anfang, keine Rechtsberatung. Prüfen Sie, was an Ihrem Standort gilt.",
installed: "Installiert",
notInstalled: "Nicht installiert",
installedCount_one: "{{installed}} von {{count}} Checkliste",
installedCount_other: "{{installed}} von {{count}} Checklisten",
newAvailable_one: "{{count}} neue Checkliste verfügbar",
newAvailable_other: "{{count}} neue Checklisten verfügbar",
install: "Paket installieren",
installing: "Wird installiert…",
addRecommended: "Empfohlene Checklisten hinzufügen",
upToDate: "Alles aus diesem Paket ist bereits vorhanden.",
remove: "Paket entfernen",
removeConfirmTitle: "Dieses Paket entfernen?",
removeConfirmBody: "Von Ihnen bearbeitete Checklisten bleiben. Nur unveränderte Paket-Checklisten werden entfernt; das Beispielobjekt geht mit dem letzten Paket.",
removeConfirmAction: "Entfernen",
removedToast_one: "{{count}} Checkliste entfernt.",
removedToast_other: "{{count}} Checklisten entfernt.",
removedSampleNote: "Das Beispielobjekt wurde ebenfalls entfernt.",
keptNote_one: "{{count}} Checkliste behalten, weil Sie sie bearbeitet haben.",
keptNote_other: "{{count}} Checklisten behalten, weil Sie sie bearbeitet haben.",
installedToast: "Checklisten hinzugefügt. Sie finden sie unter Checklisten.",
partialToast: "Einige Elemente konnten nicht hinzugefügt werden. Versuchen Sie es erneut.",
retry: "Erneut versuchen",
sections: {
assetTypes: "Was Sie anlegen können",
templates: "Checklisten",
maintenance: "Wartung",
compliance: "Nachzuweisen",
},
suggestions: {
title: "Aus Ihrem Branchenpaket",
body: "Vorschläge für diese Art von Objekt. Nichts wird hinzugefügt, bevor Sie es auswählen.",
addPlan: "Plan hinzufügen",
planAdded: "Hinzugefügt",
declare: "Nachweis verfolgen",
declared: "Wird verfolgt",
empty: "Für dieses Objekt gibt es nichts mehr vorzuschlagen.",
},
packs: {
property: {
name: "Immobilien",
description: "Häuser, Wohnungen und Gewerbeeinheiten — Zustand, Ein- und Auszug, Brandschutz und die zugehörigen Nachweise.",
},
fleet: {
name: "Fuhrpark",
description: "Pkw, Transporter, Lkw und Anhänger — tägliche Kontrollen, Schäden, Übergabe und Service nach Datum oder Laufleistung.",
},
equipment: {
name: "Ausrüstung",
description: "Maschinen, Werkzeuge und Geräte — Kontrollen vor Gebrauch, Zustand, Service nach Betriebsstunden und Kalibriernachweise.",
},
facilities: {
name: "Gebäudetechnik",
description: "Gebäude und ihre Technik — geplante Wartung, Sicherheitsinspektionen, Technikräume und gesetzliche Nachweise.",
},
},
},
automationDescribe: {
chosenPerson: "die gewählte Person",
chosenTeam: "das gewählte Team",
chosenChecklist: "der gewählten Checkliste",
chosenApprover: "den gewählten Genehmiger",
personAndTeam: "{{user}} und {{team}}",
theThreshold: "dem Schwellenwert",
yourUrl: "Ihre URL",
severityUrgent: "ein dringendes Problem",
severityAny: "irgendein Problem",
templateClause: " mit „{{name}}“",
assignedClause: " für {{name}}",
notifyClause: " und benachrichtigt {{who}}",
statusClause: " auf „{{status}}“",
failedFollowUp: "Wenn eine Inspektion{{template}} {{severity}} feststellt, erstellt AssetWRX einen Folgeauftrag{{assigned}}{{notify}}.",
renewalWork: "Wenn ein Zertifikat oder Dokument sein Erinnerungsdatum erreicht, erstellt AssetWRX einen Erneuerungsauftrag für die Anlage{{notify}}.",
highCostApproval: "Wenn ein Auftrag im Wert von {{amount}} oder mehr erstellt wird, bittet AssetWRX {{approver}}, ihn abzunehmen.",
unansweredChase_one: "Wenn ein Auftragnehmer {{count}} Tag lang nicht auf eine Einladung oder Angebotsanfrage geantwortet hat, benachrichtigt AssetWRX {{who}} und danach jede Woche erneut, bis eine Antwort vorliegt.",
unansweredChase_other: "Wenn ein Auftragnehmer {{count}} Tage lang nicht auf eine Einladung oder Angebotsanfrage geantwortet hat, benachrichtigt AssetWRX {{who}} und danach jede Woche erneut, bis eine Antwort vorliegt.",
inspectionCompleted: "Wenn eine Inspektion abgeschlossen wird, sendet AssetWRX ihre Details an {{host}}.",
inspectionUpdated: "Wenn eine Inspektion{{status}} aktualisiert wird, sendet AssetWRX ihre Details an {{host}}.",
jobCompleted: "Wenn ein Auftrag abgeschlossen wird, sendet AssetWRX seine Details an {{host}}.",
jobStatusChanged: "Wenn sich der Status eines Auftrags ändert, sendet AssetWRX seine Details an {{host}}.",
assetCreated: "Wenn eine Anlage erstellt wird, sendet AssetWRX ihre Details an {{host}}.",
assetDeleted: "Wenn eine Anlage gelöscht wird, sendet AssetWRX ihre Details an {{host}}.",
assetUpdated: "Wenn eine Anlage aktualisiert wird, sendet AssetWRX ihre Details an {{host}}.",
webhookTick_one: "Im Abstand von {{count}} Minute ruft AssetWRX {{host}} auf.",
webhookTick_other: "Im Abstand von {{count}} Minuten ruft AssetWRX {{host}} auf.",
inboundForward: "Wenn der eingehende Webhook dieser Automatisierung JSON empfängt, leitet AssetWRX es an {{host}} weiter.",
inboundJobStatus: "Wenn der eingehende Webhook dieser Automatisierung JSON empfängt, aktualisiert AssetWRX daraus den Status des genannten Auftrags.",
inboundCreateJob: "Wenn der eingehende Webhook dieser Automatisierung JSON empfängt, erstellt AssetWRX daraus einen Auftrag.",
manualTest: "Wenn Sie sie manuell ausführen, sendet AssetWRX eine Testnachricht an {{host}}.",
fallback: "Automatisierung",
},
};
